import React from 'react';
import moment from 'moment';
import { message } from 'antd';
import { HABIDO } from '../../../common/types/condicionSunatType';
import { ACTIVO } from '../../../common/types/estadoContribuyenteType';
import { JURIFICA, NATURAL } from '../../../common/types/tipoPersonaType';
import { DOMICILIO_FISCAL } from '../../../common/types/tipoEstablecimientoType';

import { CLIENTE_VARIOS } from '../../../common/types/clienteType';
import PaginationBase from '../../../common/base/PaginationBase';
import {
    VENTAS_COTIZACION,
    VENTAS_PEDIDO,
} from '../../../common/types/referenciaOrigenType';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { COTIZACION, NOTA_VENTA } from '../../../common/types/tipoComprobanteType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';
import { RUC, OTROS, DNI, CARNET_EXTRANJERIA, PASAPORTE } from '../../../common/types/tipoDocumentoType';
import {
    VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
    VENTA_MODIFICAR_TOTAL_PRODUCTO,
    VENTA_BLOQUEAR_IMPUESTOS,
    VALIDAR_STOCK,
    CONVERSION_MEDIDA,
    CONTROL_COMPBANTE,
    LOGISTICA_PRODUCTOS_CON_LOTE,
    SERIE_POR_PRODUCTO
} from "../../../common/types/parametroType";
import printFormatMock from '../../../common/mock/printFormatMock';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import auth from '../../../common/utility/auth';
import { lst_pendiente_pagos } from "../../../common/types/pendientePagoType";
import usuarioService from '../../../service/seguridad/usuarioService';
import { lst_tipo_impuesto } from "../../../common/types/impuestoType";

import proyectoService from '../../../service/administracion/proyectoService';
import notaVentaService from '../../../service/ventas/notaVentaService';
import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import almacenService from '../../../service/administracion/almacenService';
import padronReducidoService from '../../../service/integracion/padronReducidoService';
import productoService from '../../../service/administracion/productoService';
import clienteService from '../../../service/administracion/clienteService';
import pedidoService from "../../../service/ventas/pedidoService";
import cotizacionService from "../../../service/ventas/cotizacionService";
import comprobanteService from '../../../service/ventas/comprobanteService';
import metodoPagoservice from '../../../service/administracion/metodoPagoService';
import cuentaService from '../../../service/administracion/cuentaService';
import cajaService from '../../../service/administracion/cajaService';
import unidadMedidaService from '../../../service/administracion/unidadMedidaService';
import vehiculoService from '../../../service/logistica/vehiculoService';
import ubigeoService from '../../../service/integracion/ubigeoService';

import tipoDocumentoService from '../../../service/administracion/tipoDocumentoService';
import fenologicaService from '../../../service/administracion/fenologicaService';
import cultivoService from '../../../service/administracion/cultivoService';


import notasService from '../../../service/ventas/notasService';
import movimientoService from '../../../service/logistica/movimientoService';

import Header from '../../../components/Header';
import Filters from '../Seguimiento/Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
import ImportarModal from './ImportarModal';
import ImportarModalCotizacion from './ImportarModalCotizacion';
import FormModalCliente from '../../../modules/administracion/Cliente/FormModal';

import EditarNombreProductoModal from '../Seguimiento/EditarNombreProductoModal';
import SearchProductModal from '../../../components/SearchProductModal';
import ImprimirModal from '../Seguimiento/ImprimirModal';
import CorreoModal from '../Seguimiento/CorreoModal';
import ViewModal from '../Seguimiento/ViewModal';
import AgregarSerieModal from "../Seguimiento/AgregarSerieModal";

import configuracionService from '../../../service/seguridad/usuarioConfiguracionService';

import { VENTA } from '../../../common/types/moduloType';
import { CREAR_COPIAR_COMPRO, PUNTO_VENTA_COBRANZA, EDITAR_COMPRO, EDITAR_PRECIO_VENTA, VER_SERIES_VENTA } from '../../../common/types/configuracionType';
import { lst_tipo_afectacion } from '../../../common/types/tipoAfectacion';
import paisService from '../../../service/administracion/paisService';
import tipoComprobanteService from '../../../service/administracion/tipoComprobanteService';

var referenciaCount = 1;

export default class Index extends PaginationBase {
    _isMounted = false;
    constructor(props) {
        super(props);
        // this.props.onSetBreadcrumb();
        this.state = {
            loadingNew: false,
            loadingSource: true,
            loadingCopy: false,
            loadingImprimir: false,
            loadingPdf: false,
            loadingExcel: false,
            monedas: [],
            tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            vendedores: [],
            clientes: [],
            direcciones: [],
            tiposComprobante: [],
            productos: [],
            detracciones: [],
            pendientePago: lst_pendiente_pagos,
            proyectos: [],
            metodosPagos: [],
            cuentas: [],
            caja: [],
            estado: [],
            cultivos: [],
            unidadesMedida: [],
            permisosUsuario: [],
            configuraciones: [],
            totaldocument: [],
            company: {},
            filter: {
                idTipoComprobante: NOTA_VENTA.ID,
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                serie: '',
                idEstado: 0,
                documento: '',
                vehiculo: '',
                cliente: "",
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues(),
            productoModal: {
                nombre: '',
                dataSource: []
            },
            editarNombreProductoFormValues: {
                id: '',
                nombre: ''
            },
            importarCotizacionFormValues: {
                nombre: "",
                dataSource: [],
                selectedRowKeys: [],
            },
            onSetFieldsValue: null,
            onGetFieldValue: null,
            searchProductVisible: false,
            searchProductFormValues: {
                validarStock: false,
                dataSource: []
            },
            emitirVisible: false,
            emitirFilePdf: undefined,
            imprimirVisible: false,
            imprimirFormValues: {
                file: undefined,
                idComprobante: 0,
                idFormato: 0,
                isEpson: false,
                formatos: printFormatMock.values
            },
            correoFormValues: {
                file: undefined,
                id: 0,
                correoCliente: ''
            },
            cdrVisible: false,
            selectedItem: {},
            viewVisible: false,
            viewFormValues: {},
            importarVisible: false,
            importarFormValues: {
                nombre: "",
                dataSource: [],
                selectedRowKeys: [],
            },
            agregarSerieModal: {
                serie: '',
                idProducto: 0,
                listaDetalleSerie: [],
                selectedRowKeys: []
            },
            idCotizacionImportado: 0,
            visibleCliente: false,


            tiposPersona: [],
            tiposDocumento: [],
            condicionesSunat: [],
            estadosContribuyente: [],
            tiposRelacion: [],
            departamentos: [],
            tiposEstablecimiento: [],
            paises: [],
            formValuesCliente: this.fetchEmptyFormValuesCliente()
        }
    };


    // fetchEmptyFormValues = () => {
    //     return {
    //         id: 0,
    //         idTipoComprobante: NOTA_VENTA.ID,
    //         idCliente: 0,
    //         idEstablecimientoCliente: 0,
    //         // idProyecto: 0
    //         idVendedor: 0,
    //         idAlmacen: 0,
    //         idMoneda: SOLES,
    //         idListaPrecio: 0,
    //         idProyecto: 0,
    //         // idComprobanteEstado: 0,
    //         idEstablecimiento: 0,
    //         idDetraccion: 0,
    //         idUsuarioRegistro: auth.user().id,
    //         serie: "",
    //         documento: "",
    //         fechaStr: global.fetchCurrentDateStr(),
    //         fechaVencimientoStr: global.fetchCurrentDateStr(),
    //         diasVencimiento: 0,
    //         numeroPlaca: "",
    //         tipoCambio: 0,
    //         observacion: "",
    //         flagExportacion: false,
    //         flagPercepcion: false,
    //         flagDetraccion: false,
    //         // flagAnticipo: false,
    //         listaComprobanteDetalle: [],
    //         listaComprobanteReferencia: [],
    //         /*********************/
    //         sumaTotalDetalle: 0,
    //         sumaImporteDescuento: 0,
    //         sumaSubTotal: 0,
    //         sumaIgv: 0,
    //         sumaIsc: 0,
    //         sumaTotal: 0,
    //         porcentajeDetraccion: 0,
    //         importeDetraccion: 0,
    //         totalDetraccion: 0,
    //         porcentajePercepcion: 0,
    //         importePercepcion: 0,
    //         totalPercepcion: 0,
    //         totalDetailDisabled: auth.user().parametros.filter(m => m.abreviatura === VENTA_MODIFICAR_TOTAL_PRODUCTO)[0].valor === "1" ? false : true,
    //         almacenLoading: false,
    //         clienteLoading: false,
    //         activeKey: "1",
    //         documentoCliente: "",
    //         monedas: [],
    //         listasPrecio: [],
    //         establecimientos: [],
    //         almacenes: [],
    //         vendedores: [],
    //         clientes: [],
    //         direcciones: [],
    //         tiposComprobante: [],
    //         detracciones: [],
    //         detalleProductos: [],
    //         proyectos: []
    //     }
    // };

    fetchEmptyFormValues = (objEdit) => {
        return {
            id: objEdit !== undefined ? objEdit.notaVenta.id : 0,
            idTipoComprobante: NOTA_VENTA.ID,
            idCliente: objEdit !== undefined ? objEdit.notaVenta.idCliente : 0,
            idEstablecimientoCliente: objEdit !== undefined ? objEdit.notaVenta.idEstablecimientoCliente : 0,
            // idProyecto: 0
            idVendedor: objEdit !== undefined ? objEdit.notaVenta.idVendedor : 0,
            idAlmacen: objEdit !== undefined ? objEdit.notaVenta.idAlmacen : 0,
            idMoneda: objEdit !== undefined ? objEdit.notaVenta.idMoneda : SOLES,
            idListaPrecio: objEdit !== undefined ? objEdit.notaVenta.idListaPrecio : 0,
            idProyecto: objEdit !== undefined ? objEdit.notaVenta.idProyecto : 0,
            // idComprobanteEstado: 0,
            idEstablecimiento: objEdit !== undefined ? objEdit.notaVenta.idEstablecimiento : 0,
            idDetraccion: 0,
            //idCaja: objEdit !== undefined ? objEdit.notaVenta.idCaja : 0,
            idPendiente: auth.user().planCode == "PLA003" ? 1 : (objEdit !== undefined ? objEdit.notaVenta.idPendientePago : 2),
            idUsuarioRegistro: auth.user().id,
            serie: objEdit !== undefined ? objEdit.notaVenta.serie : "",
            documento: objEdit !== undefined ? objEdit.notaVenta.documento : "",
            fechaStr: objEdit !== undefined ? objEdit.notaVenta.fechaStr : global.fetchCurrentDateStr(),
            fechaVencimientoStr: objEdit !== undefined ? objEdit.notaVenta.fechaVencimientoStr : global.fetchCurrentDateStr(),
            diasVencimiento: objEdit !== undefined ? objEdit.notaVenta.diasVencimiento : 0,
            numeroPlaca: objEdit !== undefined ? objEdit.notaVenta.numeroPlaca : "",
            tipoCambio: objEdit !== undefined ? objEdit.notaVenta.tipoCambio : 0,
            observacion: objEdit !== undefined ? objEdit.notaVenta.observacion : "",
            flagExportacion: false,
            flagPercepcion: false,
            flagDetraccion: false,
            flagPago: false,
            flagCobranzaDirecta: false,
            idVehiculo: objEdit !== undefined ? objEdit.notaVenta.idVehiculo : 0,
            encargado: objEdit !== undefined ? objEdit.notaVenta.encargado : "",
            // flagAnticipo: false,
            flagGrifo: false,
            flagImpuesto: auth.user().parametros.filter(m => m.abreviatura === VENTA_BLOQUEAR_IMPUESTOS)[0].valor === "1" ? true : false,
            flagEmpresaTaller: false,
            otroImpuesto: 0,//auth.user().parametros.filter(m => m.abreviatura === IMPUESTO_PROMOCION_MUNICIPAL)[0].valor === "1" ? 2 : 1,
            flagTipoBusquedaScanner: 0,

            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            listaComprobanteMetodoPago: [],
            metodosPagos: [],
            cuentas: [],
            caja: [],
            pendientePago: [],
            unidadesMedida: [],
            vehiculos: [],
            cultivos: [],
            fenologicas: [],
            /*********************/
            sumaTotalDetalle: objEdit !== undefined ? objEdit.notaVenta.totalDetalle : 0,
            sumaImporteDescuento: objEdit !== undefined ? objEdit.notaVenta.importeDescuento : 0,
            sumaSubTotal: objEdit !== undefined ? objEdit.notaVenta.subTotal : 0,
            sumaIgv: objEdit !== undefined ? objEdit.notaVenta.igv : 0,
            sumaIsc: objEdit !== undefined ? objEdit.notaVenta.isc : 0,
            sumaTotal: objEdit !== undefined ? objEdit.notaVenta.total : 0,
            porcentajeDetraccion: 0,
            importeDetraccion: 0,
            totalDetraccion: 0,
            porcentajePercepcion: 0,
            importePercepcion: 0,
            totalPercepcion: 0,
            precioUnitarioDetailDisabled: false,
            totalDetailDisabled: auth.user().parametros.filter(m => m.abreviatura === VENTA_MODIFICAR_TOTAL_PRODUCTO)[0].valor === "1" ? false : true,
            almacenLoading: false,
            clienteLoading: false,
            activeKey: "1",
            documentoCliente: objEdit !== undefined ? objEdit.notaVenta.numeroDocumentoCliente : "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            vendedores: [],
            clientes: [],
            direcciones: [],
            tiposComprobante: [],
            detracciones: [],
            detalleProductos: [],
            proyectos: [],
            Tipoimpuesto: lst_tipo_impuesto,
            idTipoPrecio: [],
            configuraciones: [],
            idCultivo: objEdit !== undefined ? objEdit.notaVenta.idCultivo : 0,
            idFenologica: objEdit !== undefined ? objEdit.notaVenta.idFenologica : 0,


        }
    };

    handleClearFilters = () => {
        var filter = {
            idTipoComprobante: NOTA_VENTA.ID,
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            serie: this.state.filter.serie,
            documento: '',
            idEstado: 0,
            vehiculo: '',
            cliente: "",
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await notaVentaService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de notaVentas.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await notaVentaService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de notaVentas.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await notaVentaService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }
    handleImprimir = async (item) => {
        this.setState({ loadingImprimir: true });

        var file = undefined;
        var idFormato = this.state.company.formatoPrint;
        var isEpson = JSON.parse(localStorage.getItem("isEpson"));

        var response;
        if (idFormato === 1) {
            response = await notaVentaService.pdfA4({ id: item.id });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await notaVentaService.ticket({
                id: item.id,
                isEpson: isEpson == null ? false : isEpson
            });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 3) {
            response = await notaVentaService.ticket58({ id: item.id });
            file = window.URL.createObjectURL(response.data);
        }
        this.setState({
            imprimirVisible: true,
            loadingImprimir: false,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file,
                fileName: item.serie + '-' + item.documento,
                idComprobante: item.id
            }
        });
    };

    handleCorreo = async (item) => {
        //var response = await notaVentaService.pdfA4({ id: item.id });
        var file = undefined;// window.URL.createObjectURL(response.data);
        this.setState({
            correoVisible: true,
            correoFormValues: {
                ...this.state.correoFormValues,
                file,
                id: item.id,
                correoCliente: item.correoCliente
            }
        });
    };

    handleEnviarCorreo = async (data, form) => {
        dialog.confirm('¿Desea enviar el correo?', async () => {
            var response = await notaVentaService.enviarCorreo(data);

            if (response.status === 200) {
                form.resetFields();
                dialog.success('El correo ha sido enviado.');
                this.setState({ correoVisible: false });
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleView = async (item) => {
        var response = await notaVentaService.ver({ id: item.id });
        if (response !== undefined) {
            this.setState({
                viewVisible: true,
                viewFormValues: response
            });
        }
    }
    /******************** FORM MODAL *****************/

    handleEdit = async (item) => {

        var flagCrear = this.state.configuraciones.filter((m) => m.abreviatura === EDITAR_COMPRO).length >= 1 ? true : false;
        var flagPrecioEditar = this.state.configuraciones.filter((m) => m.abreviatura === EDITAR_PRECIO_VENTA).length >= 1 ? false : true;
        var flagCobranzaDirecta = this.state.configuraciones.filter((m) => m.abreviatura === PUNTO_VENTA_COBRANZA).length >= 1 ? true : false;

        if (!flagCrear) {
            message.warning('Usted no puede editar nota de venta.');
            return;
        }

        const response = await notaVentaService.obtenerPorId(item.id);
        if (response === undefined) {
            dialog.error("Ocurrió un error mientras se obtenia los datos.");
            return;
        }
        var params = auth.user().parametros;

        var conversionMedida = params.filter((m) => m.abreviatura === CONVERSION_MEDIDA)[0].valor === "1" ? true : false;

        var formValues = this.fetchEmptyFormValues(response);
        formValues.monedas = this.state.monedas;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.establecimientos = this.state.permisosUsuario.length > 0 ? this.handleEstablecimiento() : this.state.establecimientos;
        formValues.vendedores = this.state.vendedores;
        formValues.tiposComprobante = this.state.tiposComprobante.length === 0 ? await tipoComprobanteService.listar() : this.state.tiposComprobante;
        formValues.listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === formValues.idEstablecimiento);
        if (response.notaVenta.idListaPrecio == 0 || response.notaVenta.idListaPrecio == undefined) {
            formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        }
        formValues.detracciones = this.state.detracciones;
        formValues.proyectos = this.state.proyectos;
        formValues.metodosPagos = this.state.metodosPagos;
        formValues.cuentas = this.state.cuentas.filter(e => e.idMoneda == response.notaVenta.idMoneda);
        formValues.caja = this.state.caja;
        formValues.pendientePago = this.state.pendientePago;
        formValues.unidadesMedida = this.state.unidadesMedida;
        formValues.otroImpuesto = response.notaVenta.tipoImpuesto;
        formValues.precioUnitarioDetailDisabled = flagPrecioEditar;
        formValues.flagCobranzaDirecta = auth.user().planCode == "PLA003" ? flagCobranzaDirecta : false;

        formValues.flagGrifo = this.state.company.idTipoEmpresa == 1 ? true : false;
        formValues.flagEmpresaGrifo = this.state.company.idTipoEmpresa == 1 ? true : false;
        formValues.flagEmpresaTaller = this.state.company?.idTipoEmpresa === 5;
        formValues.tipoAfectacion = lst_tipo_afectacion;

        //const productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);
        const clientes = await clienteService.getByComprobante({
            id: formValues.idCliente,
            value: '',
            type: [OTROS.CODIGO, DNI.CODIGO, CARNET_EXTRANJERIA.CODIGO, RUC.CODIGO, PASAPORTE.CODIGO].join(',')
        });
        const clienteFiltered = clientes.filter((m) => m.id === formValues.idCliente);

        formValues.clientes = clientes;
        formValues.documentoCliente =
            clienteFiltered.length > 0 ? clienteFiltered[0].numeroDocumento : "";
        const direcciones = await establecimientoService.listarPorIdEntidad(response.notaVenta.idEntidadCliente);
        var almacenes = await almacenService.listarPorIdEstablecimiento(response.notaVenta.idEstablecimiento);
        const vehiculos = await vehiculoService.obtenerPorClienteId(formValues.idCliente);
        const fenologicas = formValues.idCultivo == 0 ? [] : await fenologicaService.obtenerPorCultivoId(formValues.idCultivo);

        if (almacenes != undefined && this.state.permisosUsuario.length > 0) {
            var newArray = new Array();
            var valido = false;
            var esta = formValues.establecimientos.filter(data => data.id == formValues.idEstablecimiento);

            this.state.permisosUsuario.forEach(e => {
                var regg = almacenes.filter(data => data.id == e.idAlmacen);
                if (regg.length > 0) {
                    var item = {
                        direccion: regg[0].direccion,
                        id: regg[0].id,
                        idTipoAlmacen: regg[0].idTipoAlmacen,
                        nombre: regg[0].nombre
                    }
                    newArray.push(item);
                    if (formValues.idAlmacen == regg[0].id) {
                        valido = true
                    }
                }
            });
            almacenes = newArray;
            formValues.idAlmacen = valido ? response.notaVenta.idAlmacen : null;
            formValues.idEstablecimiento = esta.length == 0 ? null : formValues.idEstablecimiento;
            formValues.idListaPrecio = esta.length == 0 ? null : formValues.idListaPrecio;

        }
        // conversion de medida por lista de precio
        formValues.idTipoPrecio = this.state.listasPrecio.filter((m) => m.id == formValues.idListaPrecio);

        response.notaVentaDetalles.forEach(row => {
            const identifier = global.fetchUniqueCode();
            var itemsConversion = [];
            if (conversionMedida) {
                itemsConversion = row.itemConversion == null ? [] : JSON.parse(row.itemConversion);
            }
            formValues.listaComprobanteDetalle.push(
                {
                    identifier: identifier,
                    idProducto: row.idProducto,
                    idTipoProducto: row.idTipoProducto,
                    codigo: row.codigoReferencia,
                    nombre: row.nombre,
                    numeroLote: row.numeroLote,
                    precioPromedio: row.precioPromedio,
                    porcentajeMargenComercial: row.porcentajeMargenComercial,
                    nombreUnidadMedida: row.nombreUnidadMedida,
                    idUnidadMedida: row.idUnidadMedida,
                    flagAfecto: row.flagAfecto,
                    flagGratuito: row.flagGratuito,
                    flagISC: row.flagISC,
                    isc: row.importeISC,
                    precioUnitario: row.precioUnitario,
                    cantidad: row.cantidad,
                    totalDetalle: row.totalDetalle,
                    porcentajeDescuento: row.porcentajeDescuento,
                    importeDescuento: row.importeDescuento,
                    subTotal: row.subTotal,
                    igv: row.igv,
                    total: row.total,
                    isItemLibre: row.isItemLibre,
                    idImpuesto: row.idImpuesto,
                    flagConversion: row.flagConversion,
                    itemConversion: itemsConversion ? itemsConversion : [],
                    flagAplicarSerie: row.flagAplicarSerie,
                    listaDetalleSerie: row.listaDetalleSerie,
                    detalleSeries: row.listaDetalleSerie != null ? row.listaDetalleSerie.map(u => u.serie).join(', ') : [],
                    selectedSerie: row.listaDetalleSerie != null ? row.listaDetalleSerie.map(m => m.serie) : [],

                }
            );

            const element = row;
            formValues.detalleProductos.push({
                identifier: identifier,
                idProducto: element.idProducto,
                idTipoProducto: element.idTipoProducto,
                nombre: element.nombre,
                numeroLote: element.numeroLote,
                idUnidadMedida: element.idUnidadMedida,
                cantidad: element.cantidad,
                precioUnitarioSinIGV: element.precioUnitarioSinIGV,
                precioUnitario: element.precioUnitario,
                precioPromedio: element.precioPromedio,
                porcentajeMargenComercial: element.porcentajeMargenComercial,
                porcentajeDescuento: element.porcentajeDescuento,
                importeDescuento: element.importeDescuento,
                total: element.total,
                flagAfecto: element.flagAfecto,
                flagISC: element.flagISC,
                flagOtrosImpuesto: element.flagOtrosImpuesto,
                flagGratuito: element.flagGratuito,
                flagChangeTotal: element.flagChangeTotal,
                subTotal: element.subTotal,
                isItemLibre: element.isItemLibre,
                flagConversion: row.flagConversion,
                idImpuesto: element.idImpuesto,
                itemConversion: itemsConversion ? itemsConversion : [],
                flagAplicarSerie: element.flagAplicarSerie,
                listaDetalleSerie: row.listaDetalleSerie,
                detalleSeries: row.listaDetalleSerie != null ? row.listaDetalleSerie.map(u => u.serie).join(', ') : [],
                selectedSerie: row.listaDetalleSerie != null ? row.listaDetalleSerie.map(m => m.serie) : [],

            });
        });

        response.notaVentaReferencias.forEach(element => {
            formValues.listaComprobanteReferencia.push({
                identifier: global.fetchUniqueCode(),
                idTipoComprobante: element.idTipoComprobante,
                serie: element.serie,
                documento: element.documento,
                idReferencia: element.idReferencia,
                idReferenciaOrigen: element.idReferenciaOrigen,
                flagInterno: element.flagInterno
            });
        });

        response.notaVentaMetodoPago.forEach(element => {
            formValues.listaComprobanteMetodoPago.push({
                identifier: global.fetchUniqueCode(),
                fechaPago: element.fechaPagoStr,
                idCuenta: element.idCuenta,
                idMetodoPago: element.idMetodoPago,
                montoPago: element.montoPago,
                estado: element.estado
            });
        });

        formValues.direcciones = direcciones;
        formValues.almacenes = almacenes;
        formValues.vehiculos = vehiculos;
        formValues.fenologicas = fenologicas;
        formValues.cultivos = this.state.cultivos;



        this.setState({
            // loadingNew: false,
            visible: true,
            formValues
        });


    }

    handleCopy = async (item) => {

        var flagCrear = this.state.configuraciones.filter((m) => m.abreviatura === CREAR_COPIAR_COMPRO).length >= 1 ? true : false;
        var flagPrecioEditar = this.state.configuraciones.filter((m) => m.abreviatura === EDITAR_PRECIO_VENTA).length >= 1 ? false : true;
        var flagCobranzaDirecta = this.state.configuraciones.filter((m) => m.abreviatura === PUNTO_VENTA_COBRANZA).length >= 1 ? true : false;
        var params = auth.user().parametros;

        if (!flagCrear) {
            message.warning('Usted no puede editar nota de venta.');
            return;
        }

        var controlDcumento = params.filter((m) => m.abreviatura === CONTROL_COMPBANTE)[0].valor === "1" ? true : false;
        if (controlDcumento) {
            if (this.state.totaldocument[0].total > auth.user().totalDocumentos) {
                message.error('Usted no puede crear comprobantes. ya supero la cantidad contratada');
                return;
            }
        }

        const response = await notaVentaService.obtenerPorId(item.id);
        if (response === undefined) {
            dialog.error("Ocurrió un error mientras se obtenia los datos.");
            return;

        }

        var conversionMedida = params.filter((m) => m.abreviatura === CONVERSION_MEDIDA)[0].valor === "1" ? true : false;

        response.notaVenta.id = 0;
        response.notaVenta.fechaStr = global.fetchCurrentDateStr();
        response.notaVenta.fechaVencimientoStr = global.fetchCurrentDateStr();

        var formValues = this.fetchEmptyFormValues(response);
        formValues.monedas = this.state.monedas;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.establecimientos = this.state.permisosUsuario.length > 0 ? this.handleEstablecimiento() : this.state.establecimientos;
        formValues.vendedores = this.state.vendedores;
        formValues.tiposComprobante = this.state.tiposComprobante.length === 0 ? await tipoComprobanteService.listar() : this.state.tiposComprobante;
        formValues.listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === formValues.idEstablecimiento);
        if (response.notaVenta.idListaPrecio == 0 || response.notaVenta.idListaPrecio == undefined) {
            formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        }

        formValues.detracciones = this.state.detracciones;
        formValues.clientes = this.state.clientes;
        formValues.proyectos = this.state.proyectos;
        formValues.metodosPagos = this.state.metodosPagos;
        formValues.cuentas = this.state.cuentas.filter(e => e.idMoneda == response.notaVenta.idMoneda);
        formValues.caja = this.state.caja;
        formValues.pendientePago = this.state.pendientePago;
        formValues.unidadesMedida = this.state.unidadesMedida;
        formValues.otroImpuesto = response.notaVenta.tipoImpuesto;
        formValues.idProyecto = 0;
        formValues.precioUnitarioDetailDisabled = flagPrecioEditar;
        formValues.flagCobranzaDirecta = auth.user().planCode == "PLA003" ? flagCobranzaDirecta : false;
        formValues.flagGrifo = this.state.company.idTipoEmpresa == 1 ? true : false;
        formValues.flagEmpresaGrifo = this.state.company.idTipoEmpresa == 1 ? true : false;
        formValues.flagEmpresaTaller = this.state.company?.idTipoEmpresa === 5;
        formValues.tipoAfectacion = lst_tipo_afectacion;

        //const productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);
        const clientes = await clienteService.getByComprobante({
            id: formValues.idCliente,
            value: '',
            type: [OTROS.CODIGO, DNI.CODIGO, CARNET_EXTRANJERIA.CODIGO, RUC.CODIGO, PASAPORTE.CODIGO].join(',')
        });
        const clienteFiltered = clientes.filter((m) => m.id === formValues.idCliente);

        formValues.clientes = clientes;

        const direcciones = await establecimientoService.listarPorIdEntidad(response.notaVenta.idEntidadCliente);
        var almacenes = await almacenService.listarPorIdEstablecimiento(response.notaVenta.idEstablecimiento);
        const vehiculos = await vehiculoService.obtenerPorClienteId(formValues.idCliente);
        const fenologicas = formValues.idCultivo == 0 ? [] : await fenologicaService.obtenerPorCultivoId(formValues.idCultivo);

        if (almacenes != undefined && this.state.permisosUsuario.length > 0) {
            var newArray = new Array();
            var valido = false;
            var esta = formValues.establecimientos.filter(data => data.id == formValues.idEstablecimiento);

            this.state.permisosUsuario.forEach(e => {
                var regg = almacenes.filter(data => data.id == e.idAlmacen);
                if (regg.length > 0) {
                    var item = {
                        direccion: regg[0].direccion,
                        id: regg[0].id,
                        idTipoAlmacen: regg[0].idTipoAlmacen,
                        nombre: regg[0].nombre
                    }
                    newArray.push(item);
                    if (formValues.idAlmacen == regg[0].id) {
                        valido = true
                    }
                }
            });
            almacenes = newArray;
            formValues.idAlmacen = valido ? response.notaVenta.idAlmacen : null;
            formValues.idEstablecimiento = esta.length == 0 ? null : formValues.idEstablecimiento;
            formValues.idListaPrecio = esta.length == 0 ? null : formValues.idListaPrecio;
        }
        response.notaVentaDetalles.forEach(row => {
            const identifier = global.fetchUniqueCode();

            var itemsConversion = [];
            if (conversionMedida) {
                itemsConversion = row.itemConversion == null ? [] : JSON.parse(row.itemConversion);
            }
            formValues.listaComprobanteDetalle.push(
                {
                    identifier: identifier,
                    idProducto: row.idProducto,
                    idTipoProducto: row.idTipoProducto,
                    codigo: row.codigoReferencia,
                    nombre: row.nombre,
                    numeroLote: row.numeroLote,
                    precioPromedio: row.precioPromedio,
                    porcentajeMargenComercial: row.porcentajeMargenComercial,
                    nombreUnidadMedida: row.nombreUnidadMedida,
                    idUnidadMedida: row.idUnidadMedida,
                    flagAfecto: row.flagAfecto,
                    flagGratuito: row.flagGratuito,
                    flagISC: row.flagISC,
                    isc: row.importeISC,
                    precioUnitario: row.precioUnitario,
                    cantidad: row.cantidad,
                    totalDetalle: row.totalDetalle,
                    porcentajeDescuento: row.porcentajeDescuento,
                    importeDescuento: row.importeDescuento,
                    subTotal: row.subTotal,
                    igv: row.igv,
                    total: row.total,
                    idImpuesto: row.idImpuesto,
                    isItemLibre: row.isItemLibre,
                    flagConversion: row.flagConversion,
                    itemConversion: itemsConversion ? itemsConversion : []

                }
            );

            const element = row;
            formValues.detalleProductos.push({
                identifier: identifier,
                idProducto: element.idProducto,
                idTipoProducto: element.idTipoProducto,
                nombre: element.nombre,
                numeroLote: element.numeroLote,
                idUnidadMedida: row.idUnidadMedida,
                cantidad: element.cantidad,
                precioUnitarioSinIGV: element.precioUnitarioSinIGV,
                precioUnitario: element.precioUnitario,
                precioPromedio: element.precioPromedio,
                porcentajeMargenComercial: element.porcentajeMargenComercial,
                porcentajeDescuento: element.porcentajeDescuento,
                importeDescuento: element.importeDescuento,
                total: element.total,
                flagAfecto: element.flagAfecto,
                flagISC: element.flagISC,
                flagOtrosImpuesto: element.flagOtrosImpuesto,
                flagGratuito: element.flagGratuito,
                flagChangeTotal: element.flagChangeTotal,
                subTotal: element.subTotal,
                idImpuesto: element.idImpuesto,
                isItemLibre: element.isItemLibre,
                flagConversion: row.flagConversion,
                itemConversion: itemsConversion ? itemsConversion : []

            });
        });
        // conversion de medida por lista de precio
        formValues.idTipoPrecio = this.state.listasPrecio.filter((m) => m.id == formValues.idListaPrecio);

        /*      response.notaVentaMetodoPago.forEach(element => {
                 formValues.listaComprobanteMetodoPago.push({
                     identifier: global.fetchUniqueCode(),
                     fechaPago: element.fechaPagoStr,
                     idCuenta: element.idCuenta,
                     idMetodoPago: element.idMetodoPago,
                     montoPago: element.montoPago,
                     estado: element.estado
                 });
             }); */

        formValues.direcciones = direcciones;
        formValues.almacenes = almacenes;
        formValues.vehiculos = vehiculos;
        formValues.fenologicas = fenologicas;
        formValues.cultivos = this.state.cultivos;


        this.setState({
            // loadingNew: false,
            visible: true,
            formValues
        });

    }

    handleNew = async () => {

        var flagCrear = this.state.configuraciones.filter((m) => m.abreviatura === CREAR_COPIAR_COMPRO).length >= 1 ? true : false;
        var flagPrecioEditar = this.state.configuraciones.filter((m) => m.abreviatura === EDITAR_PRECIO_VENTA).length >= 1 ? false : true;
        var flagCobranzaDirecta = this.state.configuraciones.filter((m) => m.abreviatura === PUNTO_VENTA_COBRANZA).length >= 1 ? true : false;
        var params = auth.user().parametros;

        if (!flagCrear) {
            message.warning('Usted no puede editar nota de venta.');
            return;
        }

        var controlDcumento = params.filter((m) => m.abreviatura === CONTROL_COMPBANTE)[0].valor === "1" ? true : false;
        if (controlDcumento) {
            if (this.state.totaldocument[0].total > auth.user().totalDocumentos) {
                message.error('Usted no puede crear comprobantes. ya supero la cantidad contratada');
                return;
            }
        }

        const clientes = await clienteService.getByComprobante({
            id: CLIENTE_VARIOS,
            value: '',
            type: [OTROS.CODIGO, DNI.CODIGO, CARNET_EXTRANJERIA.CODIGO, RUC.CODIGO, PASAPORTE.CODIGO].join(',')
        });

        this.setState({ loadingNew: true });
        var formValues = this.fetchEmptyFormValues();
        formValues.monedas = this.state.monedas;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.establecimientos = this.state.permisosUsuario.length > 0 ? this.handleEstablecimiento() : this.state.establecimientos;
        formValues.vendedores = this.state.vendedores;
        formValues.tiposComprobante = this.state.tiposComprobante.length === 0 ? await tipoComprobanteService.listar() : this.state.tiposComprobante;
        formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        formValues.detracciones = this.state.detracciones;
        formValues.clientes = clientes;
        formValues.proyectos = this.state.proyectos;
        formValues.pendientePago = this.state.pendientePago;
        formValues.otroImpuesto = this.state.company.idTipoImpuesto;
        formValues.flagGrifo = this.state.company.idTipoEmpresa == 1 ? true : false;
        formValues.flagEmpresaGrifo = this.state.company.idTipoEmpresa == 1 ? true : false;
        formValues.flagClaim = this.state.company.idTipoEmpresa == 2 ? true : false;
        formValues.flagEmpresaTaller = this.state.company?.idTipoEmpresa === 5;

        formValues.flagGiroNegocio = this.state.company?.idTipoEmpresa === 4;

        formValues.metodosPagos = this.state.metodosPagos;
        formValues.cuentas = this.state.cuentas.filter(e => e.idMoneda == SOLES);
        formValues.caja = this.state.caja;
        formValues.unidadesMedida = this.state.unidadesMedida;
        formValues.precioUnitarioDetailDisabled = flagPrecioEditar;
        formValues.flagCobranzaDirecta = auth.user().planCode == "PLA003" ? flagCobranzaDirecta : false;
        formValues.cultivos = this.state.cultivos;
        formValues.tipoAfectacion = lst_tipo_afectacion;

        var cliente_varios = formValues.clientes.filter(m => m.id === CLIENTE_VARIOS);
        if (cliente_varios.length !== 0) {
            formValues.idCliente = CLIENTE_VARIOS;
            const direcciones = await establecimientoService.listarPorIdEntidad(cliente_varios[0].idEntidad);
            formValues.documentoCliente = cliente_varios[0].numeroDocumento;
            formValues.direcciones = direcciones ? direcciones : [];
            formValues.idEstablecimientoCliente = direcciones.length > 0 ? direcciones[0].id : undefined;
        }

        const productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);
        const datosInicialesFilter = {
            idUsuario: auth.user().id,
            idTipoComprobante: NOTA_VENTA.ID
        }
        const datosIniciales = await notaVentaService.datosIniciales(datosInicialesFilter);

        if (datosIniciales !== undefined) {
            formValues.idVendedor = datosIniciales.idVendedor;
            formValues.idAlmacen = datosIniciales.idAlmacen;
            formValues.idEstablecimiento = datosIniciales.idEstablecimiento;
            formValues.idListaPrecio = datosIniciales.idListaPrecio;
            formValues.serie = datosIniciales.serie;
            //formValues.idCaja = datosIniciales.idCaja;
        }


        if (formValues.idEstablecimiento > 0) {
            const almacenes = await almacenService.listarPorIdEstablecimiento(formValues.idEstablecimiento);
            var almacenFilter = almacenes.filter(almacen => almacen.idTipoAlmacen == 1);
            if (almacenFilter != undefined && this.state.permisosUsuario.length > 0) {
                var esta = formValues.establecimientos.filter(data => data.id == formValues.idEstablecimiento);
                var valido = false;
                var newArray = new Array();
                this.state.permisosUsuario.forEach(e => {
                    var regg = almacenFilter.filter(data => data.id == e.idAlmacen);
                    if (regg.length > 0) {
                        var item = {
                            direccion: regg[0].direccion,
                            id: regg[0].id,
                            idTipoAlmacen: regg[0].idTipoAlmacen,
                            nombre: regg[0].nombre
                        }
                        newArray.push(item);
                        if (formValues.idAlmacen == regg[0].id) {
                            valido = true
                        }
                    }

                });
                almacenFilter = newArray;
                formValues.idEstablecimiento = esta.length == 0 ? null : formValues.idEstablecimiento;
                formValues.idAlmacen = valido ? formValues.idAlmacen : null;

                formValues.idListaPrecio = esta.length == 0 ? null : formValues.idListaPrecio;
            }

            const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === formValues.idEstablecimiento);
            formValues.almacenes = almacenFilter ? almacenFilter : [];
            formValues.listasPrecio = listasPrecio ? listasPrecio : [];
        }


        if (formValues.serie == "" || formValues.serie == null) {
            setTimeout(() => {
                dialog.error("Tiene que registrar serie correlativo para poder emitir el documento");

            }, 100);

        } else {

            this.setState({
                loadingNew: false,
                visible: true,
                formValues,
                productos: productos ? productos : []
            });
        }


    };

    handleEstablecimiento = () => {
        var newEstablecimiento = new Array();

        if (this.state.permisosUsuario.length == 0) {
            return newEstablecimiento;
        } else {
            //return establecimiento group by
            const Oreturn = this.handleGroupBy(this.state.permisosUsuario);

            Oreturn.forEach(element => {
                var obj = this.state.establecimientos.filter(m => m.id == element);
                if (obj.length > 0) {
                    var item = {
                        codigoSunat: obj[0].codigoSunat,
                        direccion: obj[0].direccion,
                        id: obj[0].id,
                        idDepartamento: obj[0].idDepartamento,
                        idProvincia: obj[0].idProvincia,
                        idTipoEstablecimiento: obj[0].idTipoEstablecimiento,
                        idUbigeo: obj[0].idUbigeo,
                        nombre: obj[0].nombre,
                        nombreTipoEstablecimiento: obj[0].nombreTipoEstablecimiento
                    }
                    newEstablecimiento.push(item);

                }
            });

        }
        return newEstablecimiento;
    }

    handleGroupBy(array) {
        var lista = new Array();
        array.forEach(element => {
            lista.push(element.idEstablecimiento);
        });

        return lista.filter((item, index) => lista.indexOf(item) === index);
    }

    handleSave = async (item, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            item.idCotizacion = this.state.idCotizacionImportado;

            if (item.id === 0)
                response = await notaVentaService.registrar(item);
            else
                response = await notaVentaService.modificar(item);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((item.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
        const filter = (tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario).filter(m => m.idMoneda === idMoneda);
        if (filter.length > 0)
            return parseFloat(filter[0].venta).toFixed(3);
        else
            return '0.000';
    };

    handleChangeForm = async (property, value, form) => {


        if (property === "fechaStr") {
            const fecha = moment(value, 'DD/MM/YYYY');
            const fechaVencimiento = moment(form.getFieldValue('fechaVencimientoStr'), 'DD/MM/YYYY');
            const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(value);

            form.setFieldsValue({
                tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario),
                diasVencimiento: fechaVencimiento.diff(fecha, 'days').toString()
            });
        }

        if (property === "idMoneda") {

            var cuentas = this.state.cuentas.filter(e => e.idMoneda == value);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idMoneda: value,
                    listaComprobanteMetodoPago: [],
                    cuentas: cuentas
                }
            });
        }

        if (property === "idCliente") {
            const direcciones = await establecimientoService.listarPorIdEntidad(value.split("-")[0]);
            var vehiculos = await vehiculoService.obtenerPorClienteId(value.split("-")[1]);
            vehiculos = vehiculos.filter(e => e.flag)

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direcciones: direcciones ? direcciones : [],
                    vehiculos: vehiculos ? vehiculos : []

                }
            }, () => {
                form.setFieldsValue({
                    idEstablecimientoCliente: { key: direcciones.length > 0 ? direcciones[0].id : undefined },
                    //idVehiculo: { key: vehiculos.length > 0 ? vehiculos[0].id : undefined },

                });
            });
        }

        if (property === "idCultivo") {
            const fenologicas = await fenologicaService.obtenerPorCultivoId(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    fenologicas: fenologicas ? fenologicas : [],
                }
            },
                () => {
                    form.setFieldsValue({
                        idFenologica: {
                            key: undefined,
                        },
                    });
                }
            );
        }

        if (property === "idPendiente") {
            //1 contado
            var listaComprobanteMetodoPago = this.state.formValues.listaComprobanteMetodoPago;


            if (listaComprobanteMetodoPago.length > 0 && value == 1) { // PENDIENTE

                dialog.confirm("Al cambiar el estado se eliminaran el Método de Pago \n ¿Esta seguro de realizar la acción?", () => {

                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            listaComprobanteMetodoPago: [],
                            idPendiente: value,

                        }
                    });

                }, () => {

                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            idPendiente: 2,

                        }
                    });

                }

                );


            } else {
                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        idPendiente: (value === 1 ? 1 : 2),

                    },
                });
            }




            this.setState({ isPendienteSi: value == 1 ? false : true });

        }

        if (property == "otroImpuesto") {
            var data = form.getFieldValue(property);

            if (this.state.formValues.listaComprobanteDetalle.length > 0) {

                dialog.confirm(
                    <span>
                        Al cambiar el tipo de impuesto se removera los productos agregados previamente.
                        <br />
                        <span>¿Deseas continuar?'</span>
                    </span>,
                    async () => {

                        this.setState({
                            formValues: {
                                ...this.state.formValues,
                                listaComprobanteDetalle: [],
                                detalleProductos: [],
                                listaComprobanteCuota: [],
                                listaComprobanteReferencia: [],
                            },
                        });
                        form.setFieldsValue({
                            sumaTotalDetalle: 0,
                            sumaImporteDescuento: 0,
                            sumaSubTotal: 0,
                            sumaIgv: 0,
                            sumaIsc: 0,
                            sumaTotal: 0,
                            porcentajeDetraccion: 0,
                            importeDetraccion: 0,
                            totalDetraccion: 0,
                            porcentajePercepcion: 0,
                            importePercepcion: 0,
                            totalPercepcion: 0,
                            detalleProductos: [],
                            listaComprobanteDetalle: [],
                        });
                    },
                    () =>
                        form.setFieldsValue({
                            [property]: data,
                        })
                );
            }
        }


        if (property === "direcciones-clear") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idCliente: undefined,
                    idEstablecimientoCliente: undefined,
                    documentoCliente: '',
                    direcciones: [],
                    idVehiculo: undefined,
                    encargado: '',
                }
            })
        }

        if (property === "idEstablecimiento" || property === "idListaPrecio" || property === "idAlmacen") {

            var data = form.getFieldValue(property);
            var label = property === "idEstablecimiento" ? "el establecimiento" : property === "idListaPrecio" ? "la lista de precio" : "el almacén";
            if (this.state.formValues.listaComprobanteDetalle.length > 0) {
                dialog.confirm(<span>Al cambiar {label} se removera los productos agregados previamente.<br /><span>¿Deseas continuar?'</span></span>,
                    async () => {

                        if (property === "idEstablecimiento") {
                            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
                            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
                            var almacenFilter = almacenes.filter(almacen => almacen.idTipoAlmacen == 1);
                            if (almacenFilter != undefined && this.state.permisosUsuario.length > 0) {
                                var newArray = new Array();
                                this.state.permisosUsuario.forEach(e => {
                                    var regg = almacenFilter.filter(data => data.id == e.idAlmacen);
                                    if (regg.length > 0) {
                                        var item = {
                                            direccion: regg[0].direccion,
                                            id: regg[0].id,
                                            idTipoAlmacen: regg[0].idTipoAlmacen,
                                            nombre: regg[0].nombre
                                        }
                                        newArray.push(item);
                                    }

                                });
                                almacenFilter = newArray;
                            }
                            const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === value);
                            this.setState({
                                formValues: {
                                    ...this.state.formValues,
                                    almacenLoading: false,
                                    almacenes: almacenFilter ? almacenFilter : [],
                                    listasPrecio: listasPrecio ? listasPrecio : []
                                }
                            });

                            form.setFieldsValue({
                                detalleProductos: [],
                                idAlmacen: undefined,
                                idListaPrecio: undefined
                            });
                        }

                        this.setState({
                            formValues: {
                                ...this.state.formValues,
                                listaComprobanteDetalle: [],
                                detalleProductos: []
                            },
                        });
                        form.setFieldsValue({
                            sumaTotalDetalle: 0,
                            sumaImporteDescuento: 0,
                            sumaSubTotal: 0,
                            sumaIgv: 0,
                            sumaIsc: 0,
                            sumaTotal: 0,
                            porcentajeDetraccion: 0,
                            importeDetraccion: 0,
                            totalDetraccion: 0,
                            porcentajePercepcion: 0,
                            importePercepcion: 0,
                            totalPercepcion: 0,
                            detalleProductos: [],
                            listaComprobanteDetalle: [],
                        });

                    }, () => form.setFieldsValue({ [property]: data, detalleProductos: [] }));
            }
            else {
                if (property === "idEstablecimiento") {
                    this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
                    const almacenes = await almacenService.listarPorIdEstablecimiento(value);
                    var almacenFilter = almacenes.filter(almacen => almacen.idTipoAlmacen == 1);
                    if (almacenFilter != undefined && this.state.permisosUsuario.length > 0) {
                        var newArray = new Array();
                        this.state.permisosUsuario.forEach(e => {
                            var regg = almacenFilter.filter(data => data.id == e.idAlmacen);
                            if (regg.length > 0) {
                                var item = {
                                    direccion: regg[0].direccion,
                                    id: regg[0].id,
                                    idTipoAlmacen: regg[0].idTipoAlmacen,
                                    nombre: regg[0].nombre
                                }
                                newArray.push(item);
                            }

                        });
                        almacenFilter = newArray;
                    }
                    const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === value);
                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            almacenLoading: false,
                            almacenes: almacenFilter ? almacenFilter : [],
                            listasPrecio: listasPrecio ? listasPrecio : []
                        }
                    });

                    form.setFieldsValue({
                        detalleProductos: [],
                        idAlmacen: undefined,
                        idListaPrecio: undefined
                    });
                }
                form.setFieldsValue({
                    detalleProductos: []
                });
            }
        }
    };

    handleSwitch = async (e) => {
        localStorage.setItem("isEpson", JSON.stringify(e))
        this.setState({
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                isEpson: e,
            }
        })

        setTimeout(() => {
            this.handleChangeImprimir(2)
        }, 100);
    }

    handleChangeImprimir = async (idFormato) => {
        var file = undefined;
        var response = undefined;
        if (idFormato === 1) {
            response = await notaVentaService.pdfA4({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await notaVentaService.ticket({
                id: this.state.imprimirFormValues.idComprobante,
                isEpson: JSON.parse(localStorage.getItem("isEpson")),
            });
            file = window.URL.createObjectURL(response.data);
        }
        if (idFormato === 3) {
            response = await notaVentaService.ticket58({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }


        this.setState({
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file,
                isEpson: JSON.parse(localStorage.getItem("isEpson"))
            }
        });
    };

    handleDownloadPdf = async () => {
        debugger
        var response = undefined;
        var file = undefined;

        /*       if (this.state.imprimirFormValues.idFormato === 1) {
                response = await notaVentaService.pdfA4({
                  id: this.state.imprimirFormValues.idComprobante,
                });
                file = window.URL.createObjectURL(response.data);
              }
          
              if (this.state.imprimirFormValues.idFormato === 2) {
                response = await notaVentaService.ticket({
                  id: this.state.imprimirFormValues.idComprobante,
                });
                file = window.URL.createObjectURL(response.data);
              }
          
              if (this.state.imprimirFormValues.idFormato === 3) {
                response = await notaVentaService.ticket50({
                  id: this.state.imprimirFormValues.idComprobante,
                });
                file = window.URL.createObjectURL(response.data);
              }
          
              if (response !== undefined)
                global.dowloadFile( 
                  response.data,
                  this.state.imprimirFormValues.fileName + ".pdf"
                ); */

        global.downloadFileBlob(this.state.imprimirFormValues.file, this.state.imprimirFormValues.fileName + ".pdf");

    };

    handleBuscarCliente = async (value, form) => {
        this.setState({ formValues: { ...this.state.formValues, clienteLoading: true } });

        //const response = await padronReducidoService.factura(value);

        var numberDocument = form.getFieldValue("documentoCliente");
        if (numberDocument == "" || numberDocument == "null" || numberDocument == "undefined") {
            dialog.warning(<ul>Ingrese documento valido</ul>);

            return;
        }
        var response = undefined;

        switch (numberDocument.length) {
            case 8:
                response = await padronReducidoService.obtenerDniApi(value);
                break;
            case 11:
                response = await padronReducidoService.obtenerRucApi(value);
                break;
            default:
                response = await padronReducidoService.boleta(value);
                break;
        }



        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
            this.setState({ formValues: { ...this.state.formValues, clienteLoading: false } });

            return;
        }
        var vehiculos = await vehiculoService.obtenerPorClienteId(response.data.idCliente);


        if (response.status === 200) {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    clienteLoading: false,
                    direcciones: response.data.direcciones,
                    vehiculos: vehiculos ? vehiculos : [],
                    documentoCliente: numberDocument
                }
            }, () => {
                form.setFieldsValue({
                    clientes: response.data.clientes,
                    idCliente: response.data.clientes.length > 0 ? { key: response.data.clientes[0].id } : undefined,
                    idEstablecimientoCliente: response.data.direcciones.length > 0 ? { key: response.data.direcciones[0].id } : undefined
                });
            });
        }
        else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    clienteLoading: false,
                    direcciones: [],
                }
            }, () => {
                form.setFieldsValue({
                    clientes: [],
                    idCliente: undefined,
                    idEstablecimientoCliente: undefined
                });
            });
        }
    };

    fetchEmptyFormValuesCliente = () => {
        return {
            id: 0,
            idTipoPersona: 1,
            idTipoDocumento: DNI.ID,
            numeroDocumento: '',
            razonSocial: '',
            nombre: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            correo: '',
            idEstadoContribuyente: ACTIVO,
            idCondicionSunat: HABIDO,
            idTipoRelacion: 0,
            idVendedor: 0,
            nombreTipoEstablecimiento: '',
            telefono: '',
            idDepartamento: 0,
            idProvincia: 0,
            idUbigeo: 0,
            idPais: 0,
            direccion: '',
            /******************/
            searchLoading: false,
            flagPersonaJuridica: false,
            flagPersonaNatural: true,
            tiposPersona: [],
            tiposDocumento: [],
            condicionesSunat: [],
            estadosContribuyente: [],
            tiposEstablecimiento: [],
            tiposRelacion: [],
            vendedores: [],
            departamentos: [],
            provincias: [],
            distritos: [],
            paises: [],
        }
    };

    handleNewCliente = async (onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue,
        });
        debugger
        var formValuesCliente = this.fetchEmptyFormValuesCliente();
        var tipoEstablecimientoFiltered = this.state.tiposEstablecimiento.filter(m => m.id === DOMICILIO_FISCAL.ID);
        var tiposPersonaFiltered = this.state.tiposPersona.filter(m => m.codigo === NATURAL.CODIGO);

        formValuesCliente.tiposPersona = this.state.tiposPersona;
        formValuesCliente.paises = this.state.paises;
        formValuesCliente.tiposDocumento = this.state.tiposDocumento;
        formValuesCliente.condicionesSunat = this.state.condicionesSunat;
        formValuesCliente.estadosContribuyente = this.state.estadosContribuyente;
        formValuesCliente.tiposRelacion = this.state.tiposRelacion;
        formValuesCliente.vendedores = this.state.vendedores;
        formValuesCliente.departamentos = this.state.departamentos;
        formValuesCliente.idTipoPersona = tiposPersonaFiltered.length === 0 ? 0 : tiposPersonaFiltered[0].id
        formValuesCliente.nombreTipoEstablecimiento = tipoEstablecimientoFiltered.length === 0 ? '' : tipoEstablecimientoFiltered[0].nombre;

        this.setState({ visibleCliente: true, formValuesCliente });
    };

    handleChangeFormCliente = async (property, value) => {
        if (property === "idDepartamento") {
            const provincias = await ubigeoService.provincias(value);
            this.setState({
                formValuesCliente: {
                    ...this.state.formValuesCliente,
                    provincias: provincias ? provincias : [],
                    distritos: []
                }
            });
        }

        if (property === "idProvincia") {
            const distritos = await ubigeoService.distritos(value);
            this.setState({
                formValuesCliente: {
                    ...this.state.formValuesCliente,
                    distritos: distritos ? distritos : []
                }
            });
        }

        if (property === "clear") {
            this.setState({
                formValuesCliente: {
                    ...this.state.formValuesCliente,
                    provincias: [],
                    distritos: []
                }
            });
        }
    };

    handleSaveCliente = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (values.id === 0)
                response = await clienteService.registrar(values);
            else
                response = await clienteService.modificar(values);

            if (response.status === 200) {
                form.resetFields();

                const clientes = await clienteService.listar();
                var cliente = clientes.filter(m => m.id === response.data);

                const idEntidad = cliente.length > 0 ? cliente[0].idEntidad : 0;
                const direcciones = await establecimientoService.listarPorIdEntidad(idEntidad);


                var formValues = {
                    ...this.state.formValues,
                    clientes: clientes,
                    direcciones: direcciones,
                    idCliente: cliente[0].id,
                    documentoCliente: cliente[0].numeroDocumento,
                    idEstablecimientoCliente: direcciones[0].id,
                };

                this.setState({
                    clientes: formValues.clientes,
                    formValues: formValues
                }, () => {

                    this.state.onSetFieldsValue({
                        idCliente: formValues.idCliente !== 0 ? { key: formValues.idCliente } : undefined,
                        idEstablecimientoCliente: formValues.idEstablecimientoCliente !== 0 ? { key: formValues.idEstablecimientoCliente } : undefined,
                        documentoCliente: formValues.documentoCliente
                    });
                });


                this.setState({ visibleCliente: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    searchTimeout = null;
    handleSearchPaises = (value, form) => {
        // Limpiar timeout anterior
        clearTimeout(this.searchTimeout);

        // No buscar si está vacío o tiene menos de 3 caracteres
        if (!value || value.trim().length < 3) {
            return;
        }

        this.searchTimeout = setTimeout(async () => {
            this.setState({ fetching: true });

            try {
                const response = await paisService.getBySearch({
                    id: 0,
                    value: value
                });

                if (response) {
                    form.setFieldsValue({
                        paises: response,
                    });
                }
            } finally {
                this.setState({ fetching: false });
            }
        }, 500); // Espera 500 ms después de la última tecla
    };


    handleBuscarPadronReducido = async (idTipoDocumento, numeroDocumento, form) => {
        this.setState({ formValuesCliente: { ...this.state.formValuesCliente, searchLoading: true } });
        const response = await padronReducidoService.entidad({ idTipoDocumento, numeroDocumento });
        if (response.status === 200) {
            const provincias = await ubigeoService.provincias(response.data.idDepartamento);
            const distritos = await ubigeoService.distritos(response.data.idProvincia);
            this.setState({
                formValuesCliente: {
                    ...this.state.formValuesCliente,
                    searchLoading: false,
                    provincias,
                    distritos
                }
            }, () => {
                form.setFieldsValue({
                    razonSocial: response.data.razonSocial,
                    nombre: response.data.nombre,
                    apellidoMaterno: response.data.apellidoMaterno,
                    apellidoPaterno: response.data.apellidoPaterno,
                    idCondicionSunat: { key: response.data.idCondicionSunat },
                    idEstadoContribuyente: { key: response.data.idEstadoContribuyente },
                    idDepartamento: { key: response.data.idDepartamento !== 0 ? response.data.idDepartamento : undefined },
                    idProvincia: { key: response.data.idProvincia !== 0 ? response.data.idProvincia : undefined },
                    idUbigeo: { key: response.data.idUbigeo !== 0 ? response.data.idUbigeo : undefined },
                    direccion: response.data.direccion,
                });
            });
        }
        else {
            this.setState({
                formValuesCliente: {
                    ...this.state.formValuesCliente,
                    searchLoading: false
                }
            });
        }
    };

    onCalculateMetodoPago = (totalCompra) => {
        var listaComprobanteMetodoPago = this.state.formValues.listaComprobanteMetodoPago;

        if (listaComprobanteMetodoPago.length == 1) {
            var newPago = [];

            listaComprobanteMetodoPago.forEach((key) => {
                newPago.push({
                    identifier: key.identifier,
                    fechaPago: key.fechaPago,
                    idMetodoPago: key.idMetodoPago, //efectivo
                    idCuenta: key.idCuenta,
                    referencia: key.referencia,
                    montoPago: totalCompra
                });

            });

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteMetodoPago: newPago
                }
            });

        }

    }

    handleItemLibre = (row, form, idTipoServicio) => {

        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;


        var item = {
            identifier: global.fetchUniqueCode(),
            idProducto: 8,
            idTipoProducto: idTipoServicio == 2 ? 2 : 1,
            nombre: 'ITEM LIBRE' + this.state.formValues.listaComprobanteDetalle.length,
            nombreUnidadMedida: idTipoServicio == 2 ? 'UNIDAD (SERVICIOS)' : 'UNIDAD (BIENES)',
            flagAfecto: true,
            flagGratuito: false,
            flagExonerado: false,
            flagISC: false,
            isc: 0,
            precioUnitario: 0,
            cantidad: 0,
            totalDetalle: 0,
            porcentajeDescuento: 0,
            porcentajeMargenComercial: 0,
            precioPromedio: 0,
            importeDescuento: 0,
            subTotal: 0,
            igv: 0,
            total: 0,
            numeroLote: '',
            stock: 0,
            idUnidadMedida: 58,
            isItemLibre: true,
            idImpuesto: 1,
        };

        listaComprobanteDetalle.push(item);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle
            }
        }, () => {
            var producto = {
                identifier: item.identifier,
                idTipoProducto: item.idTipoProducto,
                idProducto: item.idProducto,
                nombre: item.nombre,
                cantidad: item.cantidad,
                precioUnitarioSinIGV: 0,
                porcentajeMargenComercial: item.porcentajeMargenComercial,
                precioPromedio: item.precioPromedio,
                precioUnitario: item.precioUnitario,
                porcentajeDescuento: item.porcentajeDescuento,
                importeDescuento: item.importeDescuento,
                total: item.total,
                flagAfecto: item.flagAfecto,
                flagExonerado: item.flagExonerado,
                flagISC: item.flagISC,
                flagOtrosImpuesto: false,
                flagGratuito: item.flagGratuito,
                flagChangeTotal: false,
                subTotal: 0,
                numeroLote: row.numeroLote,
                idImpuesto: 1,
            };

            var detalleProductos = form.getFieldValue('detalleProductos');
            detalleProductos.push(producto);
            form.setFieldsValue({
                detalleProductos: detalleProductos
            });
        });

    };


    handleBuscarProducto = async (value, form) => {

        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idMoneda = this.state.onGetFieldValue('idMoneda');
        var idListaPrecio = this.state.onGetFieldValue('idListaPrecio');

        var filter = {
            idAlmacen: idAlmacen.key,
            idMoneda: idMoneda.key,
            idListaPrecio: idListaPrecio.key,
            codigoNombre: value
        }

        var response = await productoService.stock(filter);
        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                validarStock: response.validarStock,
                dataSource: response.productos
            }
        }, () => {
            form.setFieldsValue({
                dataSource: response.productos
            });
        });
    };

    handleOpenSearchProductModal = async () => {
        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idListaPrecio = this.state.onGetFieldValue('idListaPrecio');
        var idMoneda = this.state.onGetFieldValue('idMoneda');
        if (idAlmacen === undefined || idAlmacen.key === 0) {
            message.warning('Por favor seleccione un almacén.');
            return;
        }

        if (idListaPrecio === undefined || idListaPrecio.key === 0) {
            message.warning('Por favor seleccione una lista de precio.');
            return;
        }

        var filter = {
            idAlmacen: idAlmacen.key,
            idMoneda: idMoneda.key,
            idListaPrecio: idListaPrecio.key
        }

        var response = await productoService.stock(filter);
        // var lista_stock= response.productos.length > 0 ? response.productos.filter((m) => m.stock > 0):[]

        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                validarStock: response.validarStock,
                dataSource: response.productos
            }
        });
    };

    handleSelectProduct = async (row) => {
        var params = auth.user().parametros;
        var idListaPrecio = this.state.onGetFieldValue("idListaPrecio").key;

        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
        var listaComprobanteMetodoPago = this.state.formValues.listaComprobanteMetodoPago;
        var conversionMedida = params.filter((m) => m.abreviatura === CONVERSION_MEDIDA)[0].valor === "1" ? true : false;
        var empresa_salud = this.state.company.idTipoEmpresa == 3 ? true : false; //EMPRESA_SECTOR_SALUD
        var producto_lote = params.filter((m) => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1";

        var listaPrecio = 0;
        var itemsConversion = [];
        if (conversionMedida) {
            itemsConversion = await productoService.listarConversionProductoPorId(row.id);
            listaPrecio = this.state.listasPrecio.filter((m) => m.id == idListaPrecio);
        }

        // ✅ VALIDACIÓN DINÁMICA
        const existe = listaComprobanteDetalle.some(det => {
            if (producto_lote) {
                // valida producto + lote
                return det.idProducto === row.id &&
                    det.numeroLote === row.numeroLote;
            }
            return false;
        });
        if (existe && producto_lote) {
            dialog.info("Este producto con el mismo lote ya fue agregado.");
            return;
        }

        if (listaComprobanteDetalle.length == 0) {

            listaComprobanteMetodoPago.push({
                identifier: global.fetchUniqueCode(),
                fechaPago: global.fetchCurrentDateStr(),
                idMetodoPago: 4, //efectivo
                idCuenta: 0,
                referencia: "",
                montoPago: 0
            });

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteMetodoPago: listaComprobanteMetodoPago
                }
            });

        }

        var item = {
            identifier: global.fetchUniqueCode(),
            idProducto: row.id,
            idTipoProducto: row.idTipoProducto,
            codigo: row.codigoReferencia,
            nombre: empresa_salud ? row.nombre + ' (Lt. ' + row.numeroLote + '- FV ' + row.fechaVencimientoStr + ')' : row.nombre,
            nombreUnidadMedida: row.nombreUnidadMedida,
            flagAfecto: row.flagIGVAfecto,
            flagGratuito: row.flagGratuito,
            flagISC: row.flagISC,
            isc: 0,
            precioUnitario: row.precioUnitario,
            precioPromedio: row.precioPromedio,
            porcentajeMargenComercial: row.porcentajeMargenComercial,
            cantidad: 0,
            totalDetalle: 0,
            porcentajeDescuento: 0,
            importeDescuento: 0,
            subTotal: 0,
            igv: 0,
            total: 0,
            numeroLote: row.numeroLote,
            stock: row.stockDisponible,
            idUnidadMedida: 0,
            idImpuesto: row.idImpuesto,
            itemConversion: itemsConversion ? itemsConversion : [],
            flagConversion: false,
            flagAplicarSerie: row.flagAplicarSerie,
            listaDetalleSerie: [],
            selectedSerie: []
        };

        listaComprobanteDetalle.push(item);

        this.setState({
            formValues: {
                ...this.state.formValues,
                idTipoPrecio: listaPrecio,
                listaComprobanteDetalle: listaComprobanteDetalle
            }
        }, () => {
            var producto = {
                identifier: item.identifier,
                idProducto: item.idProducto,
                idTipoProducto: row.idTipoProducto,
                nombre: item.nombre,
                cantidad: item.cantidad,
                precioUnitarioSinIGV: 0,
                precioPromedio: row.precioPromedio,
                porcentajeMargenComercial: row.porcentajeMargenComercial,
                precioUnitario: item.precioUnitario,
                porcentajeDescuento: item.porcentajeDescuento,
                importeDescuento: item.importeDescuento,
                total: item.total,
                flagAfecto: item.flagAfecto,
                flagISC: item.flagISC,
                flagOtrosImpuesto: false,
                flagGratuito: item.flagGratuito,
                flagChangeTotal: false,
                subTotal: 0,
                idImpuesto: row.idImpuesto,
                numeroLote: row.numeroLote,
                idUnidadMedida: 0,
                itemConversion: itemsConversion ? itemsConversion : [],
                flagConversion: false,
                flagAplicarSerie: row.flagAplicarSerie,
                listaDetalleSerie: [],
                selectedSerie: []
            };

            var detalleProductos = this.state.onGetFieldValue('detalleProductos');
            detalleProductos.push(producto);
            this.state.onSetFieldsValue({ detalleProductos });
            this.state.onSetFieldsValue({ idTipoPrecio: listaPrecio });

        });
    };


    handleSelectConversion = async (dataItem, value, index, identifier) => {

        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle.filter((m) => m.identifier !== identifier);

        var idAlmacen = this.state.onGetFieldValue("idAlmacen");
        var idMoneda = this.state.onGetFieldValue("idMoneda");
        var idListaPrecio = this.state.onGetFieldValue("idListaPrecio");

        var filter = {
            idAlmacen: idAlmacen.key,
            idMoneda: idMoneda.key,
            idListaPrecio: idListaPrecio.key,
            idProducto: dataItem.idProducto,
            idUnidadMedida: value,
            flagConversion: true
        };

        var row = await productoService.stock_conversionMedida(filter);

        dataItem.nombreUnidadMedida = '';
        dataItem.precioPromedio = row[0].precioPromedio;
        dataItem.precioUnitario = row[0].precioUnitario;
        dataItem.cantidad = 0;
        dataItem.precioUnitarioSinIGV = 0;
        dataItem.totalDetalle = 0;
        dataItem.porcentajeDescuento = 0;
        dataItem.importeDescuento = 0;
        dataItem.subTotal = 0;
        dataItem.igv = 0;
        dataItem.total = 0;
        dataItem.idUnidadMedida = value;
        dataItem.stock = row[0].stockDisponible;
        dataItem.flagConversion = true;
        listaComprobanteDetalle.splice(index, 0, dataItem);

        this.setState(
            {
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteDetalle: listaComprobanteDetalle,
                },
            },
            () => {

                var detalleFilter = this.state.onGetFieldValue("detalleProductos");
                var detalleProductos = detalleFilter.filter((m) => m.identifier !== identifier);
                detalleProductos.splice(index, 0, dataItem);
                this.state.onSetFieldsValue({
                    detalleProductos,
                    [`arrPrecioUnitario[${identifier}]`]: dataItem.precioUnitario,

                });
            }
        );
    };


    handleScanerProduct = async (value, onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue,
        });
        // dialog.confirm(
        //   "El total de la venta excede el monto máximo establecido ¿Desea continuar?",
        //   async () => {

        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idMoneda = this.state.onGetFieldValue('idMoneda');
        var idListaPrecio = this.state.onGetFieldValue('idListaPrecio');

        if (idAlmacen === undefined) {
            message.warning('Por favor seleccione un almacén.');
            return;
        }

        if (idMoneda === undefined) {
            message.warning('Por favor seleccione la moneda.');
            return;
        }

        if (idListaPrecio === undefined) {
            message.warning('Por favor seleccione una lista de precio.');
            return;
        }

        /* PARAMETROS */
        var params = auth.user().parametros;
        var flagPrecioIncluyeIGV =
            params.filter(
                (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
            )[0].valor === "1"
                ? true
                : false;
        var porcentajeIGV = lst_tipo_impuesto.find(item => item.id === this.state.formValues.otroImpuesto)?.value ?? 18;

        /* LSITA */
        var listaComprobanteDetalle = this.state.formValues
            .listaComprobanteDetalle;
        var filter_detalle = listaComprobanteDetalle.filter(
            (m) => m.codigoBarra === value
        );

        var item = {};
        if (filter_detalle.length > 0) {
            listaComprobanteDetalle = listaComprobanteDetalle.filter(
                (m) => m.codigoBarra !== value
            );
            var item = filter_detalle[0];
            item.cantidad = item.cantidad + 1;
        } else {
            var filter = {
                idAlmacen: idAlmacen.key,
                idMoneda: idMoneda.key,
                idListaPrecio: idListaPrecio.key,
                codigoNombre: value,
            };

            var list = await productoService.stock(filter);
            var filter_list = list.productos.filter(
                (m) => m.codigoBarra === value
            );
            if (filter_list.length === 0) {
                alert("no existe el producto");
                return;
            }
            var row = filter_list[0];

            item = {
                identifier: global.fetchUniqueCode(),
                idProducto: row.id,
                idTipoProducto: row.idTipoProducto,
                codigo: row.codigoReferencia,
                codigoBarra: row.codigoBarra,
                nombre: row.nombre,
                nombreUnidadMedida: row.nombreUnidadMedida,
                porcentajeMargenComercial: row.porcentajeMargenComercial,
                precioPromedio: row.precioPromedio,
                flagAfecto: row.flagIGVAfecto,
                flagGratuito: row.flagGratuito,
                flagISC: row.flagISC,
                flagExonerado: row.flagExonerado,
                isc: 0,
                precioUnitario: row.precioUnitario,
                cantidad: 1,
                totalDetalle: 0,
                porcentajeDescuento: 0,
                importeDescuento: 0,
                subTotal: 0,
                igv: 0,
                total: 0,
                numeroLote: row.numeroLote,
                stock: row.stockDisponible,
            };
        }

        /* CALCULOS */
        var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;
        item.precioUnitarioSinIGV = flagPrecioIncluyeIGV
            ? item.precioUnitario / divisorCalculoSubTotal
            : item.precioUnitario;
        item.totalDetalle = item.cantidad * item.precioUnitarioSinIGV;
        item.subTotal = item.cantidad * item.precioUnitarioSinIGV;
        item.igv = parseFloat(
            item.flagAfecto ? item.subTotal * (porcentajeIGV / 100) : 0
        );
        item.total = item.subTotal + item.igv;
        /* CALCULOS */

        listaComprobanteDetalle.push(item);

        this.setState(
            {
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteDetalle: listaComprobanteDetalle,
                },
            },
            () => {

                var producto = {
                    identifier: item.identifier,
                    idProducto: item.idProducto,
                    idTipoProducto: item.idTipoProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    precioUnitarioSinIGV: item.precioUnitarioSinIGV,
                    porcentajeMargenComercial: item.porcentajeMargenComercial,
                    precioPromedio: item.precioPromedio,
                    precioUnitario: item.precioUnitario,
                    porcentajeDescuento: item.porcentajeDescuento,
                    importeDescuento: item.importeDescuento,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    flagExonerado: item.flagExonerado,
                    flagISC: item.flagISC,
                    flagOtrosImpuesto: false,
                    flagGratuito: item.flagGratuito,
                    flagChangeTotal: false,
                    subTotal: 0,
                    numeroLote: item.numeroLote,
                };


                var detalleProductos = this.state.onGetFieldValue(
                    "detalleProductos"
                );
                detalleProductos = detalleProductos.filter(
                    (m) => m.identifier !== producto.identifier
                );
                detalleProductos.push(producto);
                this.state.onSetFieldsValue({
                    sumaTotalDetalle: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["totalDetalle"] || 0),
                        0
                    ),
                    sumaSubTotal: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["subTotal"] || 0),
                        0
                    ),
                    sumaIgv: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["igv"] || 0),
                        0
                    ),
                    sumaTotal: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["total"] || 0),
                        0
                    ),
                    detalleProductos: detalleProductos,
                });
            }
        );
        //   }
        // );
    };

    handleRemoverProducto = (row, form) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== row.identifier)
            },
        }, () => {
            var detalleProductos = form.getFieldValue('detalleProductos');
            form.setFieldsValue({
                detalleProductos: detalleProductos.filter(m => m.identifier !== row.identifier)
            });
        });
    };

    handleEditarNombreProducto = (row, onSetFieldsValue, onGetFieldValue) => {
        var formValues = {
            id: row.identifier,
            nombre: onGetFieldValue(`arrNombre[${row.identifier}]`)
        };

        this.setState({
            editarNombreProductoVisible: true,
            editarNombreProductoFormValues: formValues,
            onSetFieldsValue,
            onGetFieldValue
        });
    };

    handleSaveEditarNombreProducto = (values, form) => {
        var unidadMedida = this.state.onGetFieldValue(`arridUnidadMedida[${values.id}]`);

        form.resetFields();
        this.setState({ editarNombreProductoVisible: false });
        var detalleProductos = this.state.onGetFieldValue("detalleProductos");
        detalleProductos.forEach(item => {
            if (item.identifier === values.id) {
                item.nombre = values.nombre;
                item.nombreUnidadMedida = unidadMedida.key == undefined ? unidadMedida.label : unidadMedida.key
                return;
            }
        });

        this.state.onSetFieldsValue({
            detalleProductos,
            [`arrNombre[${values.id}]`]: values.nombre,
            [`arridUnidadMedida[${values.id}]`]: { key: unidadMedida.key == undefined ? unidadMedida.label : unidadMedida.key },

        });
    };


    handleAddReferencia = () => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

        listaComprobanteReferencia.push({
            identifier: global.fetchUniqueCode(),
            idReferencia: 0,
            idReferenciaOrigen: 0,
            idTipoComprobante: 0,
            series: "",
            documentos: "",
            flagInterno: true
        });

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleRemoverReferencia = (item) => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia.filter(m => m.identifier !== item.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleChangeTab = (key, onSetFieldsValue) => {

        if (key == "2") { // Referencias
            onSetFieldsValue({
                flagReferencia: true
            })
        }

        if (key == "4") { // Metodo de Pago
            onSetFieldsValue({
                flagMetodoPago: true
            })
        }
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };

    handleAgregarDetalle = (onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue
        }, () => {
            if (this.state.formValues.activeKey === "1")
                this.handleOpenSearchProductModal();

            const newLocal = "2";
            if (this.state.formValues.activeKey === newLocal)
                this.handleAddReferencia();


            const formaPagos = "4";
            if (this.state.formValues.activeKey === formaPagos)
                this.handleAddMetodoPago();

        });
    };


    handleAddMetodoPago = () => {
        debugger
        var listaComprobanteMetodoPago = this.state.formValues.listaComprobanteMetodoPago;
        listaComprobanteMetodoPago.push({
            identifier: global.fetchUniqueCode(),
            fechaPago: global.fetchCurrentDateStr(),
            idMetodoPago: 0,
            idCuenta: 0,
            referencia: "",
            montoPago: 0
        });

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteMetodoPago: listaComprobanteMetodoPago
            }
        });
    };

    handleRemoverMetodoPago = (item) => {
        var listaComprobanteMetodoPago = this.state.formValues.listaComprobanteMetodoPago.filter(m => m.identifier !== item.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteMetodoPago: listaComprobanteMetodoPago
            }
        });
    };

    handleAnular = async (item) => {
        dialog.confirm(`¿Desea anular el notaVenta ${item.serie}-${item.documento}?`, async () => {
            var response = await notaVentaService.anular({ id: item.id });

            if (response.status === 200) {
                dialog.success(`NOTA DE VENTA ${item.serie}-${item.documento} anulado correctamente.`);
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleAprobar = async (item) => {
        dialog.confirm(`¿Desea aprobar la nota Venta ${item.serie}-${item.documento}?`, async () => {
            var response = await notaVentaService.aprobar({ id: item.id });

            if (response.status === 200) {
                dialog.success(`NOTA DE VENTA ${item.serie}-${item.documento} aprobado correctamente.`);
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleEmitir = async (item) => {
        dialog.confirm(`¿Desea emitir el notaVenta ${item.serie}-${item.documento}?`, async () => {
            var response = await notaVentaService.anular({ id: item.id });

            if (response.status === 200) {
                dialog.success(`notaVenta ${item.serie}-${item.documento} emitido correctamente.`);
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleImportarPedido = async (onSetFieldsValue, onGetFieldValue) => {
        this.setState(
            {
                onSetFieldsValue,
                onGetFieldValue,
            },
            async () => {
                var idCliente = this.state.onGetFieldValue("idCliente");

                var filter = {
                    idCliente: idCliente === undefined ? 0 : idCliente.key,
                    serie: "",
                    documento: "",
                };



                if (idCliente === undefined) {
                    dialog.error("Debe seleccionar un Cliente");
                    return;
                } else {

                    var response = await pedidoService.importarRegistrados(filter);

                    this.setState({
                        importarVisible: true,
                        importarFormValues: {
                            ...this.state.importarFormValues,
                            dataSource: response,
                        },
                    });


                }

            }
        );
    };

    handleSelectPedido = async (selected, row, form) => {

        var response = undefined;
        var productos = this.state.onGetFieldValue("detalleProductos");

        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

        var sumaTotalDetalle = 0;
        var sumaImporteDescuento = 0;
        var sumaSubTotal = 0;
        var sumaIgv = 0;
        var sumaIsc = 0;
        var sumaTotal = 0;
        var obj = {};
        var totalMetodoPago = 0;



        if (row.length == 0) {

            listaComprobanteDetalle = listaComprobanteDetalle.filter(e => e.importado == true);
            listaComprobanteReferencia = listaComprobanteReferencia.filter(e => e.importado == true);
            productos = productos.filter(e => e.importado == true);

            if (listaComprobanteReferencia.length > 0)
                totalMetodoPago = parseFloat(listaComprobanteDetalle.reduce((a, b) => a + (b["total"] || 0), 0));


            setTimeout(() => {
                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        listaComprobanteDetalle,
                        listaComprobanteReferencia
                    },
                    importarFormValues: {
                        ...this.state.importarFormValues,
                        selectedRowKeys: selected
                    }
                })

                this.state.onSetFieldsValue({

                    detalleProductos: productos,
                    sumaTotalDetalle: sumaTotalDetalle + (totalMetodoPago / 1.18),
                    sumaImporteDescuento: sumaImporteDescuento,
                    sumaSubTotal: sumaSubTotal + (totalMetodoPago / 1.18),
                    sumaIgv: sumaIgv + (totalMetodoPago - (totalMetodoPago / 1.18)),
                    sumaIsc: sumaIsc,
                    sumaTotal: sumaTotal + totalMetodoPago
                });
            }, 100)
        }
        if (row.length == 1) {

            listaComprobanteDetalle = listaComprobanteDetalle.filter(e => e.importado == true);
            listaComprobanteReferencia = listaComprobanteReferencia.filter(e => e.importado == true);
            productos = productos.filter(e => e.importado == true);

            if (listaComprobanteReferencia.length > 0)
                totalMetodoPago = parseFloat(listaComprobanteDetalle.reduce((a, b) => a + (b["total"] || 0), 0));

            response = await pedidoService.obtenerPorId(row[0].id);

            response.pedidoDetalles.forEach(element => {
                const identifier = global.fetchUniqueCode();
                var itemsConversion = [];

                listaComprobanteDetalle.push({
                    identifier: identifier,
                    idProducto: element.idProducto,
                    idTipoProducto: element.idTipoProducto,
                    codigo: element.codigoReferencia,
                    nombre: element.nombre,
                    numeroLote: element.numeroLote,
                    porcentajeMargenComercial: element.porcentajeMargenComercial,
                    precioPromedio: element.precioPromedio,
                    nombreUnidadMedida: element.nombreUnidadMedida,
                    idUnidadMedida: element.idUnidadMedida,
                    flagAfecto: element.flagAfecto,
                    flagExonerado: element.flagExonerado,
                    flagGratuito: element.flagGratuito,
                    flagISC: element.flagISC,
                    isc: element.importeISC,
                    precioUnitario: element.precioUnitario,
                    cantidad: element.cantidad,
                    totalDetalle: element.totalDetalle.toFixed(2),
                    porcentajeDescuento: element.porcentajeDescuento,
                    importeDescuento: element.importeDescuento,
                    subTotal: element.subTotal,
                    igv: element.igv,
                    total: element.total,
                    flagConversion: element.flagConversion,
                    itemConversion: itemsConversion,
                    idImpuesto: element.idImpuesto,
                    flagVencimiento: element.flagVencimiento,
                    fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null
                });

                productos.push({
                    identifier: identifier,
                    idProducto: element.idProducto,
                    idTipoProducto: element.idTipoProducto,
                    nombre: element.nombre,
                    numeroLote: element.numeroLote,
                    cantidad: element.cantidad,
                    porcentajeMargenComercial: element.porcentajeMargenComercial,
                    precioPromedio: element.precioPromedio,
                    idUnidadMedida: element.idUnidadMedida,
                    precioUnitarioSinIGV: element.precioUnitarioSinIGV,
                    precioUnitario: element.precioUnitario,
                    porcentajeDescuento: element.porcentajeDescuento,
                    importeDescuento: element.importeDescuento,
                    total: element.total,
                    flagAfecto: element.flagAfecto,
                    flagISC: element.flagISC,
                    flagOtrosImpuesto: element.flagOtrosImpuesto,
                    flagGratuito: element.flagGratuito,
                    flagChangeTotal: element.flagChangeTotal,
                    subTotal: element.subTotal,
                    importado: false,
                    flagConversion: element.flagConversion,
                    itemConversion: itemsConversion,
                    flagVencimiento: element.flagVencimiento,
                    idImpuesto: element.idImpuesto,
                    fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null
                });



            });

            listaComprobanteReferencia.push({
                identifier: global.fetchUniqueCode(),
                idReferencia: response.pedido.id,
                flagInterno: true,
                idReferenciaOrigen: VENTAS_PEDIDO,
                idTipoComprobante: response.pedido.idTipoComprobante,
                serie: response.pedido.serie,
                documento: response.pedido.documento,
                importado: false,
            });

            listaComprobanteReferencia = listaComprobanteReferencia.filter(m => selected.filter(f => f === m.serie + '-' + m.documento).length);

            obj = {
                sumaTotalDetalle: response.pedido.totalDetalle + (totalMetodoPago / 1.18),
                sumaImporteDescuento: response.pedido.importeDescuento + sumaImporteDescuento,
                sumaSubTotal: response.pedido.subTotal + (totalMetodoPago / 1.18),
                sumaIgv: response.pedido.igv + (totalMetodoPago - (totalMetodoPago / 1.18)),
                sumaIsc: response.pedido.isc + sumaIsc,
                sumaTotal: response.pedido.total + totalMetodoPago,
            }


            this.SelectPedido(response, listaComprobanteDetalle, productos, listaComprobanteReferencia, selected, obj);

        }

        var contador = 0;
        if (row.length > 1) {

            listaComprobanteDetalle = listaComprobanteDetalle.filter(e => e.importado == true);
            listaComprobanteReferencia = listaComprobanteReferencia.filter(e => e.importado == true);
            productos = productos.filter(e => e.importado == true);

            if (listaComprobanteReferencia.length > 0)
                totalMetodoPago = parseFloat(listaComprobanteDetalle.reduce((a, b) => a + (b["total"] || 0), 0));

            row.forEach(async (item) => {

                response = await pedidoService.obtenerPorId(item.id);

                response.pedidoDetalles.forEach(element => {
                    const identifier = global.fetchUniqueCode();
                    var itemsConversion = [];

                    listaComprobanteDetalle.push({
                        identifier: identifier,
                        idProducto: element.idProducto,
                        idTipoProducto: element.idTipoProducto,
                        codigo: element.codigoReferencia,
                        nombre: element.nombre,
                        numeroLote: element.numeroLote,
                        nombreUnidadMedida: element.nombreUnidadMedida,
                        idUnidadMedida: element.idUnidadMedida,
                        flagAfecto: element.flagAfecto,
                        flagGratuito: element.flagGratuito,
                        flagISC: element.flagISC,
                        isc: element.importeISC,
                        porcentajeMargenComercial: element.porcentajeMargenComercial,
                        precioPromedio: element.precioPromedio,
                        precioUnitario: element.precioUnitario,
                        cantidad: element.cantidad,
                        totalDetalle: element.totalDetalle.toFixed(2),
                        porcentajeDescuento: element.porcentajeDescuento,
                        importeDescuento: element.importeDescuento,
                        subTotal: element.subTotal,
                        igv: element.igv,
                        total: element.total,
                        importado: false,
                        flagConversion: element.flagConversion,
                        itemConversion: itemsConversion,
                        flagVencimiento: element.flagVencimiento,
                        idImpuesto: element.idImpuesto,
                        fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null
                    });

                    productos.push({
                        identifier: identifier,
                        idProducto: element.idProducto,
                        idTipoProducto: element.idTipoProducto,
                        nombre: element.nombre,
                        numeroLote: element.numeroLote,
                        cantidad: element.cantidad,
                        idUnidadMedida: element.idUnidadMedida,
                        porcentajeMargenComercial: element.porcentajeMargenComercial,
                        precioPromedio: element.precioPromedio,
                        precioUnitarioSinIGV: element.precioUnitarioSinIGV,
                        precioUnitario: element.precioUnitario,
                        porcentajeDescuento: element.porcentajeDescuento,
                        importeDescuento: element.importeDescuento,
                        total: element.total,
                        flagAfecto: element.flagAfecto,
                        flagISC: element.flagISC,
                        flagOtrosImpuesto: element.flagOtrosImpuesto,
                        flagGratuito: element.flagGratuito,
                        flagChangeTotal: element.flagChangeTotal,
                        subTotal: element.subTotal,
                        importado: false,
                        flagConversion: element.flagConversion,
                        itemConversion: itemsConversion,
                        flagVencimiento: element.flagVencimiento,
                        idImpuesto: element.idImpuesto,
                        fechaVencimientoStr: element.flagVencimiento ? element.fechaVencimientoStr : null
                    });
                });

                listaComprobanteReferencia.push({
                    identifier: global.fetchUniqueCode(),
                    idReferencia: response.pedido.id,
                    flagInterno: true,
                    idReferenciaOrigen: VENTAS_PEDIDO,
                    idTipoComprobante: response.pedido.idTipoComprobante,
                    serie: response.pedido.serie,
                    documento: response.pedido.documento,
                    importado: false,
                });

                sumaTotalDetalle = response.pedido.totalDetalle + sumaTotalDetalle;
                sumaImporteDescuento = response.pedido.importeDescuento + sumaImporteDescuento;
                sumaSubTotal = response.pedido.subTotal + sumaSubTotal;
                sumaIgv = response.pedido.igv + sumaIgv;
                sumaIsc = response.pedido.isc + sumaIsc;
                sumaTotal = response.pedido.total + sumaTotal;

                contador++;

                if (contador == row.length) {
                    listaComprobanteReferencia = listaComprobanteReferencia.filter(m => selected.filter(f => f === m.serie + '-' + m.documento).length);

                    obj = {
                        sumaTotalDetalle: sumaTotalDetalle + (totalMetodoPago / 1.18),
                        sumaImporteDescuento: sumaImporteDescuento,
                        sumaSubTotal: sumaSubTotal + (totalMetodoPago / 1.18),
                        sumaIgv: sumaIgv + (totalMetodoPago - (totalMetodoPago / 1.18)),
                        sumaIsc: sumaIsc,
                        sumaTotal: sumaTotal + totalMetodoPago,
                    }

                    this.SelectPedido(response, listaComprobanteDetalle, productos, listaComprobanteReferencia, selected, obj);

                }
            })

        }



    };

    SelectPedido = async (response, listaComprobanteDetalle, productos, listaComprobanteReferencia, selected, obj) => {


        var listaMetodoPago = [];
        const almacenes = await almacenService.listarPorIdEstablecimiento(response.pedido.idEstablecimiento);
        const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === response.pedido.idEstablecimiento);
        var formValues = {
            ...this.state.formValues,
            almacenes: almacenes,
            listasPrecio: listasPrecio,
            idEstablecimiento: response.pedido.idEstablecimiento,
            idAlmacen: response.pedido.idAlmacen,
            idProyecto: response.pedido.idProyecto,
            idMoneda: response.pedido.idMoneda,
            idListaPrecio: response.pedido.idListaPrecio,
            listaComprobanteDetalle: listaComprobanteDetalle,
            listaComprobanteReferencia: listaComprobanteReferencia,
            listaComprobanteMetodoPago: listaMetodoPago,
            isImportando: true,
            encargado: response.pedido.encargado,
            idVehiculo: response.pedido.idVehiculo,
            observacion: response.pedido.observacion,
            otroImpuesto: response.pedido.tipoImpuesto,
            idVendedor: response.pedido.idVendedor,

        };

        if ((formValues.idCliente === 0 || formValues.idCliente === undefined) &&
            response.pedido.idCliente !== null && response.pedido.idCliente !== undefined &&
            formValues.clientes.filter(m => m.id === response.pedido.idCliente).length !== 0) {
            const direcciones = await establecimientoService.listarPorIdEntidad(response.pedido.idEntidadCliente);
            formValues.documentoCliente = response.pedido.numeroDocumentoCliente;
            formValues.idCliente = response.pedido.idCliente;
            formValues.direcciones = direcciones;
            formValues.idEstablecimientoCliente = direcciones[0].id;
        }


        this.setState({
            almacenes: formValues.almacenes,
            listasPrecio: formValues.listasPrecio,
            direcciones: formValues.direcciones,
            formValues: formValues,
            importarFormValues: {
                ...this.state.importarFormValues,
                selectedRowKeys: selected
            }
        }, () => {
            var detalleProductos = [];
            productos.forEach(producto => {
                detalleProductos.push(producto);
            });

            this.state.onSetFieldsValue({
                //idCliente: formValues.idCliente !== 0 ? { key: formValues.idCliente} : undefined,
                /*                idEstablecimientoCliente: formValues.idEstablecimientoCliente !== 0 ? { key: formValues.idEstablecimientoCliente} : undefined,
                               documentoCliente : formValues.documentoCliente,
                               idEstablecimiento: { key: response.cotizacion.idEstablecimiento }, */
                idAlmacen: { key: response.pedido.idAlmacen },
                idListaPrecio: { key: response.pedido.idListaPrecio },
                idMoneda: { key: response.pedido.idMoneda },
                otroImpuesto: { key: response.pedido.tipoImpuesto },
                detalleProductos: detalleProductos,
                idTipoComprobanteImportado: response.pedido.idTipoComprobante,
                sumaTotalDetalle: obj.sumaTotalDetalle,
                sumaImporteDescuento: obj.sumaImporteDescuento,
                sumaSubTotal: obj.sumaSubTotal,
                sumaIgv: obj.sumaIgv,
                sumaIsc: obj.sumaIsc,
                sumaTotal: obj.sumaTotal,
            });
        });
    }



    handleImportarCotizacion = async (onSetFieldsValue, onGetFieldValue) => {
        this.setState(
            {
                onSetFieldsValue,
                onGetFieldValue,
            },
            async () => {
                var idCliente = this.state.onGetFieldValue("idCliente");
                var idMoneda = this.state.onGetFieldValue("idMoneda");

                var filter = {
                    idCliente: idCliente === undefined ? 0 : idCliente.key,
                    serie: "",
                    documento: "",
                    idMoneda: idMoneda === undefined ? 0 : idMoneda.key,
                };

                if (idCliente === undefined) {
                    dialog.error("Debe seleccionar un Cliente");
                    return;
                } else {

                    var response = await cotizacionService.importarRegistrados(filter);
                    this.setState({
                        importarCotizacionVisible: true,
                        importarCotizacionFormValues: {
                            ...this.state.importarCotizacionFormValues,
                            dataSource: response,
                            selectedRowKeys: this.state.formValues.listaComprobanteReferencia.map(function (v) {
                                return v.serie + '-' + v.documento;
                            })
                        },
                    });

                }
            }
        );
    };

    obtenerDatosIniciales = async () => {
        const datosInicialesFilter = {
            idUsuario: auth.user().id,
            idTipoComprobante: NOTA_VENTA.ID
        }
        const datosIniciales = await comprobanteService.datosIniciales(datosInicialesFilter);

        return datosIniciales;
    }


    handleSelectCotizacion = async (selected, row, form) => {

        var response = undefined;
        var productos = this.state.onGetFieldValue("detalleProductos");

        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

        var sumaTotalDetalle = 0;
        var sumaImporteDescuento = 0;
        var sumaSubTotal = 0;
        var sumaIgv = 0;
        var sumaIsc = 0;
        var sumaTotal = 0;
        var obj = {};
        var totalMetodoPago = 0;



        if (row.length == 0) {

            listaComprobanteDetalle = listaComprobanteDetalle.filter(e => e.importado == true);
            listaComprobanteReferencia = listaComprobanteReferencia.filter(e => e.importado == true);
            productos = productos.filter(e => e.importado == true);

            if (listaComprobanteReferencia.length > 0)
                totalMetodoPago = parseFloat(listaComprobanteDetalle.reduce((a, b) => a + (b["total"] || 0), 0));


            setTimeout(() => {
                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        listaComprobanteDetalle,
                        listaComprobanteReferencia
                    },
                    importarCotizacionFormValues: {
                        ...this.state.importarCotizacionFormValues,
                        selectedRowKeys: selected
                    }
                })

                this.state.onSetFieldsValue({

                    detalleProductos: productos,
                    sumaTotalDetalle: sumaTotalDetalle + (totalMetodoPago / 1.18),
                    sumaImporteDescuento: sumaImporteDescuento,
                    sumaSubTotal: sumaSubTotal + (totalMetodoPago / 1.18),
                    sumaIgv: sumaIgv + (totalMetodoPago - (totalMetodoPago / 1.18)),
                    sumaIsc: sumaIsc,
                    sumaTotal: sumaTotal + totalMetodoPago
                });
            }, 100)
        }
        if (row.length == 1) {

            listaComprobanteDetalle = listaComprobanteDetalle.filter(e => e.importado == true);
            listaComprobanteReferencia = listaComprobanteReferencia.filter(e => e.importado == true);
            productos = productos.filter(e => e.importado == true);

            if (listaComprobanteReferencia.length > 0)
                totalMetodoPago = parseFloat(listaComprobanteDetalle.reduce((a, b) => a + (b["total"] || 0), 0));

            response = await cotizacionService.obtenerPorId(row[0].id);

            response.cotizacionDetalles.forEach(element => {
                const identifier = global.fetchUniqueCode();
                var itemsConversion = [];

                listaComprobanteDetalle.push({
                    identifier: identifier,
                    idProducto: element.idProducto,
                    idTipoProducto: element.idTipoProducto,
                    codigo: element.codigoReferencia,
                    nombre: element.nombre,
                    numeroLote: element.numeroLote,
                    nombreUnidadMedida: element.nombreUnidadMedida,
                    idUnidadMedida: element.idUnidadMedida,
                    flagAfecto: element.flagAfecto,
                    flagGratuito: element.flagGratuito,
                    flagISC: element.flagISC,
                    isc: element.importeISC,
                    porcentajeMargenComercial: element.porcentajeMargenComercial,
                    precioPromedio: element.precioPromedio,
                    precioUnitario: element.precioUnitario,
                    cantidad: element.cantidad,
                    totalDetalle: element.totalDetalle.toFixed(2),
                    porcentajeDescuento: element.porcentajeDescuento,
                    importeDescuento: element.importeDescuento,
                    subTotal: element.subTotal,
                    igv: element.igv,
                    total: element.total,
                    importado: false,
                    flagConversion: element.flagConversion,
                    itemConversion: itemsConversion,
                    flagVencimiento: element.flagVencimiento,
                    idImpuesto: element.idImpuesto,
                    fechaVencimiento: element.flagVencimiento ? element.fechaVencimientoStr : null

                });

                productos.push({
                    identifier: identifier,
                    idProducto: element.idProducto,
                    idTipoProducto: element.idTipoProducto,
                    nombre: element.nombre,
                    numeroLote: element.numeroLote,
                    cantidad: element.cantidad,
                    porcentajeMargenComercial: element.porcentajeMargenComercial,
                    precioPromedio: element.precioPromedio,
                    precioUnitarioSinIGV: element.precioUnitarioSinIGV,
                    precioUnitario: element.precioUnitario,
                    porcentajeDescuento: element.porcentajeDescuento,
                    importeDescuento: element.importeDescuento,
                    idUnidadMedida: element.idUnidadMedida,
                    total: element.total,
                    flagAfecto: element.flagAfecto,
                    flagISC: element.flagISC,
                    flagOtrosImpuesto: element.flagOtrosImpuesto,
                    flagGratuito: element.flagGratuito,
                    flagChangeTotal: element.flagChangeTotal,
                    subTotal: element.subTotal,
                    importado: false,
                    flagConversion: element.flagConversion,
                    itemConversion: itemsConversion,
                    flagVencimiento: element.flagVencimiento,
                    idImpuesto: element.idImpuesto,
                    fechaVencimiento: element.flagVencimiento ? element.fechaVencimientoStr : null
                });



            });

            listaComprobanteReferencia.push({
                identifier: global.fetchUniqueCode(),
                idReferencia: response.cotizacion.id,
                flagInterno: true,
                idReferenciaOrigen: VENTAS_COTIZACION,
                idTipoComprobante: response.cotizacion.idTipoComprobante,
                serie: response.cotizacion.serie,
                documento: response.cotizacion.documento,
                importado: false,
            });

            listaComprobanteReferencia = listaComprobanteReferencia.filter(m => selected.filter(f => f === m.serie + '-' + m.documento).length);

            obj = {
                sumaTotalDetalle: response.cotizacion.totalDetalle + (totalMetodoPago / 1.18),
                sumaImporteDescuento: response.cotizacion.importeDescuento + sumaImporteDescuento,
                sumaSubTotal: response.cotizacion.subTotal + (totalMetodoPago / 1.18),
                sumaIgv: response.cotizacion.igv + (totalMetodoPago - (totalMetodoPago / 1.18)),
                sumaIsc: response.cotizacion.isc + sumaIsc,
                sumaTotal: response.cotizacion.total + totalMetodoPago,
            }


            this.SelectCotizacion(response, listaComprobanteDetalle, productos, listaComprobanteReferencia, selected, obj);

        }

        var contador = 0;
        if (row.length > 1) {

            listaComprobanteDetalle = listaComprobanteDetalle.filter(e => e.importado == true);
            listaComprobanteReferencia = listaComprobanteReferencia.filter(e => e.importado == true);
            productos = productos.filter(e => e.importado == true);

            if (listaComprobanteReferencia.length > 0)
                totalMetodoPago = parseFloat(listaComprobanteDetalle.reduce((a, b) => a + (b["total"] || 0), 0));

            row.forEach(async (item) => {

                response = await cotizacionService.obtenerPorId(item.id);

                response.cotizacionDetalles.forEach(element => {
                    const identifier = global.fetchUniqueCode();
                    var itemsConversion = [];

                    listaComprobanteDetalle.push({
                        identifier: identifier,
                        idProducto: element.idProducto,
                        idTipoProducto: element.idTipoProducto,
                        codigo: element.codigoReferencia,
                        nombre: element.nombre,
                        numeroLote: element.numeroLote,
                        nombreUnidadMedida: element.nombreUnidadMedida,
                        idUnidadMedida: element.idUnidadMedida,
                        flagAfecto: element.flagAfecto,
                        flagGratuito: element.flagGratuito,
                        flagISC: element.flagISC,
                        isc: element.importeISC,
                        porcentajeMargenComercial: element.porcentajeMargenComercial,
                        precioPromedio: element.precioPromedio,
                        precioUnitario: element.precioUnitario,
                        cantidad: element.cantidad,
                        totalDetalle: element.totalDetalle.toFixed(2),
                        porcentajeDescuento: element.porcentajeDescuento,
                        importeDescuento: element.importeDescuento,
                        subTotal: element.subTotal,
                        igv: element.igv,
                        total: element.total,
                        importado: false,
                        flagConversion: element.flagConversion,
                        itemConversion: itemsConversion,
                        flagVencimiento: element.flagVencimiento,
                        idImpuesto: element.idImpuesto,
                        fechaVencimiento: element.flagVencimiento ? element.fechaVencimientoStr : null
                    });

                    productos.push({
                        identifier: identifier,
                        idProducto: element.idProducto,
                        idTipoProducto: element.idTipoProducto,
                        nombre: element.nombre,
                        numeroLote: element.numeroLote,
                        cantidad: element.cantidad,
                        idUnidadMedida: element.idUnidadMedida,
                        porcentajeMargenComercial: element.porcentajeMargenComercial,
                        precioPromedio: element.precioPromedio,
                        precioUnitarioSinIGV: element.precioUnitarioSinIGV,
                        precioUnitario: element.precioUnitario,
                        porcentajeDescuento: element.porcentajeDescuento,
                        importeDescuento: element.importeDescuento,
                        total: element.total,
                        flagAfecto: element.flagAfecto,
                        flagISC: element.flagISC,
                        flagOtrosImpuesto: element.flagOtrosImpuesto,
                        flagGratuito: element.flagGratuito,
                        flagChangeTotal: element.flagChangeTotal,
                        subTotal: element.subTotal,
                        importado: false,
                        flagConversion: element.flagConversion,
                        itemConversion: itemsConversion,
                        flagVencimiento: element.flagVencimiento,
                        idImpuesto: element.idImpuesto,
                        fechaVencimiento: element.flagVencimiento ? element.fechaVencimientoStr : null
                    });
                });

                listaComprobanteReferencia.push({
                    identifier: global.fetchUniqueCode(),
                    idReferencia: response.cotizacion.id,
                    flagInterno: true,
                    idReferenciaOrigen: VENTAS_COTIZACION,
                    idTipoComprobante: response.cotizacion.idTipoComprobante,
                    serie: response.cotizacion.serie,
                    documento: response.cotizacion.documento,
                    importado: false,
                });

                sumaTotalDetalle = response.cotizacion.totalDetalle + sumaTotalDetalle;
                sumaImporteDescuento = response.cotizacion.importeDescuento + sumaImporteDescuento;
                sumaSubTotal = response.cotizacion.subTotal + sumaSubTotal;
                sumaIgv = response.cotizacion.igv + sumaIgv;
                sumaIsc = response.cotizacion.isc + sumaIsc;
                sumaTotal = response.cotizacion.total + sumaTotal;

                contador++;

                if (contador == row.length) {
                    listaComprobanteReferencia = listaComprobanteReferencia.filter(m => selected.filter(f => f === m.serie + '-' + m.documento).length);

                    obj = {
                        sumaTotalDetalle: sumaTotalDetalle + (totalMetodoPago / 1.18),
                        sumaImporteDescuento: sumaImporteDescuento,
                        sumaSubTotal: sumaSubTotal + (totalMetodoPago / 1.18),
                        sumaIgv: sumaIgv + (totalMetodoPago - (totalMetodoPago / 1.18)),
                        sumaIsc: sumaIsc,
                        sumaTotal: sumaTotal + totalMetodoPago,
                    }

                    this.SelectCotizacion(response, listaComprobanteDetalle, productos, listaComprobanteReferencia, selected, obj);

                }
            })

        }



    };

    SelectCotizacion = async (response, listaComprobanteDetalle, productos, listaComprobanteReferencia, selected, obj) => {


        var listaMetodoPago = [];
        const almacenes = await almacenService.listarPorIdEstablecimiento(response.cotizacion.idEstablecimiento);
        const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === response.cotizacion.idEstablecimiento);
        var formValues = {
            ...this.state.formValues,
            almacenes: almacenes,
            listasPrecio: listasPrecio,
            idEstablecimiento: response.cotizacion.idEstablecimiento,
            idAlmacen: response.cotizacion.idAlmacen,
            idMoneda: response.cotizacion.idMoneda,
            idProyecto: response.cotizacion.idProyecto,
            idListaPrecio: response.cotizacion.idListaPrecio,
            listaComprobanteDetalle: listaComprobanteDetalle,
            listaComprobanteReferencia: listaComprobanteReferencia,
            listaComprobanteMetodoPago: listaMetodoPago,
            isImportando: true,
            encargado: response.cotizacion.encargado,
            idVehiculo: response.cotizacion.idVehiculo,
            observacion: response.cotizacion.observacion,
            otroImpuesto: response.cotizacion.tipoImpuesto,
            idVendedor: response.cotizacion.idVendedor,

        };

        if ((formValues.idCliente === 0 || formValues.idCliente === undefined) &&
            response.cotizacion.idCliente !== null && response.cotizacion.idCliente !== undefined &&
            formValues.clientes.filter(m => m.id === response.cotizacion.idCliente).length !== 0) {
            const direcciones = await establecimientoService.listarPorIdEntidad(response.cotizacion.idEntidadCliente);
            formValues.documentoCliente = response.cotizacion.numeroDocumentoCliente;
            formValues.idCliente = response.cotizacion.idCliente;
            formValues.direcciones = direcciones;
            formValues.idEstablecimientoCliente = direcciones[0].id;
        }


        this.setState({
            almacenes: formValues.almacenes,
            listasPrecio: formValues.listasPrecio,
            direcciones: formValues.direcciones,
            formValues: formValues,
            importarCotizacionFormValues: {
                ...this.state.importarCotizacionFormValues,
                selectedRowKeys: selected
            }
        }, () => {
            var detalleProductos = [];
            productos.forEach(producto => {
                detalleProductos.push(producto);
            });

            this.state.onSetFieldsValue({
                //idCliente: formValues.idCliente !== 0 ? { key: formValues.idCliente} : undefined,
                /*                idEstablecimientoCliente: formValues.idEstablecimientoCliente !== 0 ? { key: formValues.idEstablecimientoCliente} : undefined,
                               documentoCliente : formValues.documentoCliente,
                               idEstablecimiento: { key: response.cotizacion.idEstablecimiento }, */
                idAlmacen: { key: response.cotizacion.idAlmacen },
                idListaPrecio: { key: response.cotizacion.idListaPrecio },
                idMoneda: { key: response.cotizacion.idMoneda },
                idProyecto: { key: response.cotizacion.idProyecto },
                otroImpuesto: { key: response.cotizacion.tipoImpuesto },
                detalleProductos: detalleProductos,
                idTipoComprobanteImportado: response.cotizacion.idTipoComprobante,
                sumaTotalDetalle: obj.sumaTotalDetalle,
                sumaImporteDescuento: obj.sumaImporteDescuento,
                sumaSubTotal: obj.sumaSubTotal,
                sumaIgv: obj.sumaIgv,
                sumaIsc: obj.sumaIsc,
                sumaTotal: obj.sumaTotal,
            });
        });
    }

    handleAgregarSerie = async (row, onCalculateDetail, setFieldsValueDetalle, getFieldValueDetalle, index) => {
        debugger;
        var idAlmacen = this.state.onGetFieldValue === null ? this.state.formValues.idAlmacen : this.state.onGetFieldValue('idAlmacen').key;
        var listaSerieProducto = await movimientoService.listarSeriesDisponiblesComprobante({ idAlmacen: idAlmacen, idProducto: row.idProducto, numeroLote: row.numeroLote, idComprobante: this.state.formValues.id, idTipoComprobante: this.state.formValues.idTipoComprobante });

        this.setState({
            setFieldsValueDetalle,
            getFieldValueDetalle
        }, async () => {
            debugger;
            this.setState({
                agregarSerieVisible: true,
                agregarSerieModal: {
                    ...this.state.agregarSerieModal,
                    idProducto: row.idProducto,
                    codigoProducto: row.codigo,
                    nombreProducto: row.nombre,
                    serie: '',
                    listaDetalleSerie: listaSerieProducto,
                    onCalculateDetail: onCalculateDetail,
                    setFieldsValueDetalle: setFieldsValueDetalle,
                    getFieldValueDetalle: getFieldValueDetalle,
                    selectedRowKeys: row.selectedSerie,
                    index: index
                }
            });

        });
    }

    handleChangeSelectedSerie = (selected, rows, onCalculateDetail, idProductoRemoveSerie, index) => {
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;

        if (selected.length > 0) {
            listaComprobanteDetalle.forEach(detalle => {
                if (detalle.idProducto === rows[0].idProducto) {
                    detalle.selectedSerie = selected;
                    detalle.listaDetalleSerie = rows;
                    detalle.detalleSeries = detalle.listaDetalleSerie.map(u => u.serie).join(', ');
                    detalle.cantidad = detalle.listaDetalleSerie.length;
                    onCalculateDetail(detalle, "arrCantidad", detalle.cantidad, 3, index);
                }
            });
        } else {
            listaComprobanteDetalle.forEach(detalle => {
                if (detalle.idProducto === idProductoRemoveSerie) {
                    detalle.selectedSerie = [];
                    detalle.listaDetalleSerie = [];
                    detalle.detalleSeries = '';
                    detalle.cantidad = detalle.listaDetalleSerie.length;
                    onCalculateDetail(detalle, "arrCantidad", detalle.cantidad, 3, index);
                }
            });
        }

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle,
                detalleProductos: listaComprobanteDetalle
            },
            agregarSerieModal: {
                ...this.state.agregarSerieModal,
                selectedRowKeys: selected
            }
        });
    };


    searchTimeout = null;

    handleSearchClientes = (value, form) => {
        // Limpiar timeout anterior
        clearTimeout(this.searchTimeout);

        // No buscar si está vacío o tiene menos de 3 caracteres
        if (!value || value.trim().length < 3) {
            return;
        }

        this.searchTimeout = setTimeout(async () => {
            this.setState({ fetching: true });

            try {
                const response = await clienteService.getByComprobante({
                    id: 0,
                    value: value,
                    type: [OTROS.CODIGO, DNI.CODIGO, CARNET_EXTRANJERIA.CODIGO, RUC.CODIGO, PASAPORTE.CODIGO].join(',')
                });

                if (response) {
                    form.setFieldsValue({
                        clientes: response,
                    });
                }
            } finally {
                this.setState({ fetching: false });
            }
        }, 500); // Espera 500 ms después de la última tecla
    };

    async componentDidMount() {
        this._isMounted = true;
        var idUsuario = auth.user().id;

        const datosIniciales = await this.obtenerDatosIniciales();

        const configuraciones = await configuracionService.obtenerPorModulo({ idUsuario: idUsuario, idModulo: VENTA });
        var flagSerie = configuraciones.filter((m) => m.abreviatura === VER_SERIES_VENTA).length >= 1 ? true : false;

        const serie = [undefined, null].includes(datosIniciales?.serie) ? flagSerie ? '' : '-' : datosIniciales.serie;
        this.setState({ filter: { ...this.state.filter, serie } });

        this._initPagination({ ...this.state.filter, serie }, notaVentaService.paginacion);

        const permisosUsuario = await usuarioService.usarioEstablecimiento(idUsuario, 1)
        const cajas = await cajaService.listarCajaAperturada(auth.user().id);

        //const monedas = await monedaService.listar();
        const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
        //const listasPrecio = await listaPrecioService.listar();
        //const establecimientos = await establecimientoService.principales();
        //const vendedores = await vendedorService.listar();
        //const tiposComprobante = await tipoComprobanteService.listar();
        //const detracciones = await detraccionService.listar();
        //const clientes = await clienteService.listar();
        const proyectos = await proyectoService.listar();
        const estado = await notaVentaService.listarEstado();

        const response = await notasService.listar();

        const monedas = response.list_Moneda.result;
        const listasPrecio = response.list_Precio.result;
        const establecimientos = response.list_Establecimiento.result;
        const vendedores = response.list_Vendedor.result;
        const tiposComprobante =[];// response.list_TipoComprobante.result;
        const detracciones =[];// response.list_Detraccion.result;
        const clientes = [];// response.list_Cliente.result;

        const tiposPersona = response.list_TipoPersona.result;
        const condicionesSunat = response.list_CondicionSunat.result;
        const estadosContribuyente = response.list_EstadoContribuyente.result;
        const tiposEstablecimiento = response.list_TipoEstablecimiento.result;
        const tiposRelacion = response.list_TipoRelacion.result;
        const paises = [];// response.list_Pais.result;

        const totaldocument = response.list_TotalComprobante.result;

        //const tiposPersona = await tipoPersonaService.listar();
        const tiposDocumento = await tipoDocumentoService.listarExcluirPlaca();
        //const condicionesSunat = await condicionSunatService.listar();
        //const estadosContribuyente = await estadoContribuyenteService.listar();
        const departamentos = await ubigeoService.departamentos();
        //const tiposRelacion = await tipoRelacionService.listar();
        //const tiposEstablecimiento = await tipoEstablecimientoService.listar();
        //const paises = await paisService.listar();

        const cultivos = await cultivoService.listar();

        const metodosPagos = await metodoPagoservice.listar();
        const cuentas = await cuentaService.listar();
        const company = response.list_Empresa;

        //const caja = await cajaService.listar();
        const unidadesMedida = await unidadMedidaService.listar();

        if (this._isMounted) {
            this.setState({
                loadingSource: false,
                tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
                monedas: monedas ? monedas : [],
                listasPrecio: listasPrecio ? listasPrecio : [],
                establecimientos: establecimientos ? establecimientos : [],
                vendedores: vendedores ? vendedores : [],
                tiposComprobante: tiposComprobante ? tiposComprobante : [],
                detracciones: detracciones ? detracciones : [],
                clientes: clientes ? clientes : [],
                proyectos: proyectos ? proyectos : [],
                configuraciones: configuraciones ? configuraciones : [],
                metodosPagos: metodosPagos ? metodosPagos : [],
                cuentas: cuentas ? cuentas : [],
                caja: cajas ? cajas : [],
                estado: estado ? estado : [],
                unidadesMedida: unidadesMedida ? unidadesMedida : [],
                permisosUsuario: permisosUsuario ? permisosUsuario : [],

                tiposPersona: tiposPersona ? tiposPersona : [],
                tiposDocumento: tiposDocumento ? tiposDocumento : [],
                condicionesSunat: condicionesSunat ? condicionesSunat : [],
                estadosContribuyente: estadosContribuyente ? estadosContribuyente : [],
                tiposRelacion: tiposRelacion ? tiposRelacion : [],
                departamentos: departamentos ? departamentos : [],
                tiposEstablecimiento: tiposEstablecimiento ? tiposEstablecimiento : [],
                paises: paises ? paises : [],
                totaldocument: totaldocument ? totaldocument : [],
                cultivos: cultivos ? cultivos : [],
                company: company


            });
        }
    };

    componentWillUnmount() {
        this._isMounted = false;
    };

    render() {
        return (
            <div>
                <Header
                    title="Nota de Venta"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                    lista_clientes={this.state.clientes}
                    estado={this.state.estado}
                    proyectos={this.state.proyectos}
                    configuraciones={this.state.configuraciones}
                    flagEmpresaTaller={this.state.company?.idTipoEmpresa === 5}

                />

                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource || this.state.loadingSource}
                    loadingCopy={this.state.loadingCopy || this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingImprimir={this.state.loadingImprimir || this.state.loadingSource}
                    onPrint={this.handlePrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onEdit={this.handleEdit}
                    onCopy={this.handleCopy}
                    onChange={this._handleChangePagination}
                    onView={this.handleView}
                    onEmitir={this.handleEmitir}
                    onAnular={this.handleAnular}
                    onImprimir={this.handleImprimir}
                    onCorreo={this.handleCorreo}
                    onAprobar={this.handleAprobar}

                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onBuscarCliente={this.handleBuscarCliente}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onRemoverProducto={this.handleRemoverProducto}
                    onRemoverReferencia={this.handleRemoverReferencia}
                    onEditarNombreProducto={this.handleEditarNombreProducto}
                    onChangeTab={this.handleChangeTab}
                    onChange={this.handleChangeForm}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onNewCliente={this.handleNewCliente}
                    onAgregarSerie={this.handleAgregarSerie}
                    onImportar={this.handleImportar}
                    onImportarPedido={this.handleImportarPedido}
                    onImportarCotizacion={this.handleImportarCotizacion}
                    onScanerProduct={this.handleScanerProduct}
                    onRemoverMetodoPago={this.handleRemoverMetodoPago}
                    onCalculateMetodoPago={this.onCalculateMetodoPago}
                    OnItemLibre={this.handleItemLibre}
                    handleSelectConversion={this.handleSelectConversion}
                    fetchClientes={this.handleSearchClientes}
                    fetching={this.state.fetching}
                />
                <ImportarModal
                    tittle="Búsqueda de Pedido"
                    visible={this.state.importarVisible}
                    formValues={this.state.importarFormValues}
                    dataSource={this.state.importarFormValues.dataSource}
                    onSelect={this.handleSelectPedido}
                    onClose={() => this.setState({ importarVisible: false })}
                />
                <ImportarModalCotizacion
                    tittle="Búsqueda de Cotización"
                    visible={this.state.importarCotizacionVisible}
                    formValues={this.state.importarCotizacionFormValues}
                    dataSource={this.state.importarCotizacionFormValues.dataSource}
                    onSelect={this.handleSelectCotizacion}
                    onClose={() => this.setState({ importarCotizacionVisible: false })}
                />

                <SearchProductModal
                    onBuscarProducto={this.handleBuscarProducto}
                    visible={this.state.searchProductVisible}
                    validarStock={this.state.searchProductFormValues.validarStock}
                    dataSource={this.state.searchProductFormValues.dataSource}
                    dataSourceAgregado={this.state.formValues.listaComprobanteDetalle}
                    onSelect={this.handleSelectProduct}
                    onCancel={() => this.setState({ searchProductVisible: false })}
                />

                <EditarNombreProductoModal
                    visible={this.state.editarNombreProductoVisible}
                    formValues={this.state.editarNombreProductoFormValues}
                    onClose={() => this.setState({ editarNombreProductoVisible: false })}
                    onSave={this.handleSaveEditarNombreProducto}
                />

                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onDownload={this.handleDownloadPdf}
                    onSwitch={this.handleSwitch}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />
                <CorreoModal
                    visible={this.state.correoVisible}
                    formValues={this.state.correoFormValues}
                    onClose={() => this.setState({ correoVisible: false })}
                    onSend={this.handleEnviarCorreo}
                />
                <ViewModal
                    visible={this.state.viewVisible}
                    formValues={this.state.viewFormValues}
                    onClose={() => this.setState({ viewVisible: false })}
                />

                <FormModalCliente
                    visible={this.state.visibleCliente}
                    formValues={this.state.formValuesCliente}
                    onChange={this.handleChangeFormCliente}
                    onBuscarPadronReducido={this.handleBuscarPadronReducido}
                    onClose={() => this.setState({ visibleCliente: false })}
                    onSave={this.handleSaveCliente}

                    fetchPaises={this.handleSearchPaises}
                    fetching={this.state.fetching}
                />

                <AgregarSerieModal
                    visible={this.state.agregarSerieVisible}
                    formValues={this.state.agregarSerieModal}
                    onCancel={() => this.setState({ agregarSerieVisible: false })}
                    onAgregarSerieDetalle={this.handleChangeSelectedSerie}
                    onRemove={this.handleRemoverSerieDetalle}
                />
            </div>
        )
    }
}